(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("ezkA5", function(module, exports) {
    $parcel$export(module.exports, "onTagalysReady", function() {
      return $a9b44c853f7ad42f$export$8029fffc6aa71bf9;
    });
    $parcel$export(module.exports, "createProductCardHTML", function() {
      return $a9b44c853f7ad42f$export$7215210a376abae6;
    });
    var $cJzMp = parcelRequire("cJzMp");
    var $65zHg = parcelRequire("65zHg");
    const $a9b44c853f7ad42f$var$log = (0, $cJzMp.createLogger)("tagalys-helpers");
    function $a9b44c853f7ad42f$export$8029fffc6aa71bf9(callback, options = {}) {
      const {timeout: timeout = 5e3, interval: interval = 50} = options;
      $a9b44c853f7ad42f$var$log("lifecycle", "Waiting for Tagalys readiness", {
        hasWindowHook: typeof window !== "undefined" && Boolean(window.onTagalysReady),
        hasTagalys: typeof window !== "undefined" && Boolean(window.Tagalys),
        hasAPIConnector: typeof window !== "undefined" && Boolean(window.Tagalys?.APIConnector),
        hasConfig: typeof window !== "undefined" && Boolean(window.tagalysConfig),
        timeout: timeout,
        interval: interval
      });
      if (window.onTagalysReady) {
        $a9b44c853f7ad42f$var$log("lifecycle", "Using window.onTagalysReady hook");
        window.onTagalysReady(callback);
        return;
      }
      const hasTagalys = typeof window !== "undefined" && window.Tagalys && window.Tagalys.APIConnector && window.tagalysConfig;
      if (hasTagalys) {
        $a9b44c853f7ad42f$var$log("lifecycle", "Tagalys already ready");
        callback(true);
        return;
      } else {
        let elapsed = 0;
        const timer = window.setInterval(() => {
          elapsed += interval;
          const isReady = window.Tagalys && window.Tagalys.APIConnector && window.tagalysConfig;
          if (isReady) {
            window.clearInterval(timer);
            $a9b44c853f7ad42f$var$log("lifecycle", "Tagalys became ready after polling", {
              elapsed: elapsed
            });
            callback(true);
            return;
          }
          if (elapsed >= timeout) {
            window.clearInterval(timer);
            $a9b44c853f7ad42f$var$log("errors", "Timed out waiting for Tagalys readiness", {
              elapsed: elapsed,
              hasTagalys: Boolean(window.Tagalys),
              hasAPIConnector: Boolean(window.Tagalys?.APIConnector),
              hasConfig: Boolean(window.tagalysConfig)
            });
            callback(false);
          }
        }, interval);
      }
    }
    function $a9b44c853f7ad42f$export$c86caf1be068fb8d(price) {
      const locale = typeof Shopify !== "undefined" && Shopify.locale && Shopify.country ? `${Shopify.locale}-${Shopify.country}` : "en-GB";
      const currency = typeof Shopify !== "undefined" && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : "GBP";
      if (!window.tagalysConfig) return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency
      }).format(price);
      const {fractionalDigits: fractionalDigits, forceFractionalDigits: forceFractionalDigits} = window.tagalysConfig.currency;
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: forceFractionalDigits ? fractionalDigits : 0,
        maximumFractionDigits: fractionalDigits
      }).format(price);
    }
    function $a9b44c853f7ad42f$export$806849e86c43de0f(imageSrc, alt, className = "") {
      if (!imageSrc || typeof Shopify === "undefined" || !Shopify.getSizedImage) return `\n      <img\n        src="${imageSrc}"\n        alt="${alt}"\n        class="${className}"\n        loading="lazy"\n        width="400"\n        height="467"\n      />\n    `;
      const sizes = [ 320, 414, 600, 768, 1024, 1280, 1440, 1600, 1920 ];
      const srcset = sizes.map(size => `${Shopify.getSizedImage(imageSrc, size + "x")} ${size}w`).join(", ");
      const sizesAttr = "(min-width: 1024px) 22.5vw, 47.5vw";
      return `\n    <img\n      src="${Shopify.getSizedImage(imageSrc, "400x")}"\n      srcset="${srcset}"\n      sizes="${sizesAttr}"\n      alt="${alt}"\n      class="${className}"\n      loading="lazy"\n      width="400"\n      height="467"\n    />\n  `;
    }
    function $a9b44c853f7ad42f$export$6c49dedf84602800(images, galleryOptions = {}) {
      const {disableCarousel: disableCarousel, disableHoverImage: disableHoverImage} = $a9b44c853f7ad42f$var$normalizeGalleryOptions(galleryOptions);
      if (!images.length) {
        $a9b44c853f7ad42f$var$log("ui", "Product gallery skipped because no images were supplied", {
          disableCarousel: disableCarousel,
          disableHoverImage: disableHoverImage,
          images: images
        });
        return "";
      }
      if (images[0].isPlaceholderSVG) return $a9b44c853f7ad42f$var$getPlaceholderSVG("aspect-[6/7] w-full h-full bg-black-10");
      const imageOne = $a9b44c853f7ad42f$export$806849e86c43de0f(images[0].src, images[0].alt || "Product image", "w-full h-full object-cover object-center z-1");
      const hasHoverImage = !disableHoverImage && images.length > 1 && Boolean(window.MBF?.settings?.toggleHoverImage);
      $a9b44c853f7ad42f$var$log("ui", "Product gallery hover-image decision", {
        imageCount: images.length,
        disableCarousel: disableCarousel,
        disableHoverImage: disableHoverImage,
        toggleHoverImage: Boolean(window.MBF?.settings?.toggleHoverImage),
        hasHoverImage: hasHoverImage,
        reason: $a9b44c853f7ad42f$var$getHoverImageReason({
          imageCount: images.length,
          disableHoverImage: disableHoverImage,
          toggleHoverImage: Boolean(window.MBF?.settings?.toggleHoverImage)
        }),
        firstImage: $a9b44c853f7ad42f$var$summarizeImage(images[0]),
        secondImage: $a9b44c853f7ad42f$var$summarizeImage(images[1])
      });
      if (hasHoverImage) {
        const imageTwo = $a9b44c853f7ad42f$export$806849e86c43de0f(images[1].src, images[1].alt || images[0].alt || "Product image", "image-cover z-2 transition-opacity duration-500 opacity-0 desktop:group-hover:opacity-100 tablet:hidden");
        return `${imageOne}${imageTwo}`;
      }
      return imageOne;
    }
    function $a9b44c853f7ad42f$var$handleize(str) {
      return str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
    }
    function $a9b44c853f7ad42f$var$isEventProduct(product) {
      if (product.metafields?.custom?.event_type == null) return false;
      const eventHandles = window.MBF?.strings?.eventOptionHandles;
      if (!eventHandles) return true;
      const {experience: experience, date: date, time: time} = eventHandles;
      return (product.options || []).some(option => {
        const h = $a9b44c853f7ad42f$var$handleize(option.name || option || "");
        return h === experience || h === date || h === time;
      });
    }
    function $a9b44c853f7ad42f$var$isOnProductPage(productHandle) {
      if (!productHandle) return false;
      const path = window.location.pathname;
      const expectedSuffix = `/products/${productHandle}`;
      return path.endsWith(expectedSuffix);
    }
    function $a9b44c853f7ad42f$export$7215210a376abae6(product, options = {}) {
      if (!product) {
        console.error("Tagalys: Product card skipped - Product data is null or undefined");
        return "";
      }
      let images = product.images || [];
      const placeholderImage = window.tagalysConfig?.settings?.placeholder_image;
      if (images.length === 0) {
        if (placeholderImage) {
          images = [ {
            src: placeholderImage,
            alt: product.title || "Product placeholder"
          } ];
          $a9b44c853f7ad42f$var$log("ui", "Product card using custom fallback placeholder image", {
            product: $a9b44c853f7ad42f$var$summarizeProduct(product),
            placeholderImage: placeholderImage
          });
        } else {
          images = [ {
            isPlaceholderSVG: true
          } ];
          $a9b44c853f7ad42f$var$log("ui", "Product card using Shopify default SVG placeholder", {
            product: $a9b44c853f7ad42f$var$summarizeProduct(product)
          });
        }
      }
      const {class: additionalClasses = "", disableCarousel: disableCarousel = false, toggleQuickAdd: toggleQuickAdd = false, toggleDiscountBadge: toggleDiscountBadge = false, disableHoverImage: disableHoverImage = false, toggleBadges: toggleBadges = window.MBF?.settings?.toggleProductBadges ?? true, badgeLimit: badgeLimit = window.MBF?.settings?.productBadgeLimit ?? 3, mobileBadgeLimit: mobileBadgeLimit = window.MBF?.settings?.productMobileBadgeLimit ?? 1} = options;
      const priceVaries = product.price_varies || product.price_min !== product.price_max;
      const formattedPrice = $a9b44c853f7ad42f$var$trimMoneyZeros($a9b44c853f7ad42f$export$c86caf1be068fb8d(product.price));
      const formattedPriceMin = priceVaries ? $a9b44c853f7ad42f$var$trimMoneyZeros($a9b44c853f7ad42f$export$c86caf1be068fb8d(product.price_min)) : null;
      const variantCount = product.variants?.length || 0;
      const variants = product.variants || [];
      const cheapestVariant = [ ...variants ].sort((a, b) => a.price - b.price)[0];
      const cheapestIsDiscounted = Boolean(cheapestVariant && cheapestVariant.compare_at_price && cheapestVariant.compare_at_price > cheapestVariant.price);
      const formattedCheapestCompare = cheapestIsDiscounted ? $a9b44c853f7ad42f$var$trimMoneyZeros($a9b44c853f7ad42f$export$c86caf1be068fb8d(cheapestVariant.compare_at_price)) : null;
      const metafieldBadge = $a9b44c853f7ad42f$var$extractMetafieldValue(product.metafields?.custom?.price_discount_badge);
      let computedDiscountText = "";
      if (metafieldBadge) computedDiscountText = metafieldBadge; else if (toggleDiscountBadge) {
        if (priceVaries) {
          let maxDiscount = 0;
          let minDiscount = 100;
          let hasDiscount = false;
          for (const v of variants) if (v.compare_at_price && v.compare_at_price > v.price) {
            const pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
            hasDiscount = true;
            if (pct > maxDiscount) maxDiscount = pct;
            if (pct < minDiscount) minDiscount = pct;
          } else minDiscount = 0;
          if (hasDiscount) {
            const template = maxDiscount === minDiscount ? window.MBF?.strings?.product?.discount?.percentOff || "{{ percentage }}% off" : window.MBF?.strings?.product?.discount?.upToOff || "Up to {{ percentage }}% off";
            computedDiscountText = template.replace("{{ percentage }}", String(maxDiscount));
          }
        } else if (cheapestIsDiscounted) {
          const pct = Math.round((cheapestVariant.compare_at_price - cheapestVariant.price) / cheapestVariant.compare_at_price * 100);
          computedDiscountText = `${(window.MBF?.strings?.product?.save || "Save").trim()} ${pct}%`;
        }
      }
      const showBadge = Boolean(computedDiscountText);
      $a9b44c853f7ad42f$var$log("ui", "Product card render decisions", {
        product: $a9b44c853f7ad42f$var$summarizeProduct(product),
        options: {
          additionalClasses: additionalClasses,
          disableCarousel: disableCarousel,
          disableHoverImage: disableHoverImage,
          toggleQuickAdd: toggleQuickAdd,
          toggleDiscountBadge: toggleDiscountBadge,
          toggleBadges: toggleBadges,
          badgeLimit: badgeLimit,
          mobileBadgeLimit: mobileBadgeLimit
        },
        pricing: {
          priceVaries: Boolean(priceVaries),
          formattedPrice: formattedPrice,
          formattedPriceMin: formattedPriceMin,
          cheapestIsDiscounted: Boolean(cheapestIsDiscounted),
          formattedCheapestCompare: formattedCheapestCompare
        },
        discountBadge: {
          computedDiscountText: computedDiscountText,
          showBadge: Boolean(showBadge),
          hasMetafieldOverride: Boolean(metafieldBadge),
          reason: $a9b44c853f7ad42f$var$getDiscountBadgeReason({
            toggleDiscountBadge: toggleDiscountBadge,
            priceVaries: priceVaries,
            cheapestIsDiscounted: cheapestIsDiscounted,
            metafieldBadge: metafieldBadge
          })
        }
      });
      const discountBadgeMarkup = computedDiscountText ? `<div class="ml-2 tablet:w-full tablet:ml-0 tablet:order-3">\n      <div class="bg-scheme-contrast-background text-scheme-contrast-text text-sm py-[2px] px-1.5 rounded-xs leading-4 tablet:text-xs tablet:w-fit">\n        ${(0, 
      $65zHg.escapeHTML)(computedDiscountText)}\n      </div>\n    </div>` : "";
      const productTitle = (0, $65zHg.escapeHTML)(product.title || "");
      const productUrl = `${window.Shopify?.routes?.root || "/"}products/${product.handle}`;
      const _isEventProduct = $a9b44c853f7ad42f$var$isEventProduct(product);
      const hasMultipleOptions = product.options?.length > 1;
      const onOwnPage = $a9b44c853f7ad42f$var$isOnProductPage(product.handle);
      const canQuickAdd = Boolean(toggleQuickAdd && !onOwnPage && !_isEventProduct && !hasMultipleOptions);
      $a9b44c853f7ad42f$var$log("ui", "Product card quick-add decision", {
        product: $a9b44c853f7ad42f$var$summarizeProduct(product),
        canQuickAdd: canQuickAdd,
        reasons: $a9b44c853f7ad42f$var$getQuickAddReasons({
          toggleQuickAdd: toggleQuickAdd,
          onOwnPage: onOwnPage,
          isEventProduct: _isEventProduct,
          hasMultipleOptions: hasMultipleOptions
        }),
        firstVariantId: product.variants?.[0]?.id || null,
        options: product.options || []
      });
      const compareMarkup = cheapestIsDiscounted ? `<s class="text-scheme-text ml-1 empty:ml-0 empty:hidden">${formattedCheapestCompare}</s>` : "";
      const quickAddIcon = product.available ? $a9b44c853f7ad42f$var$getIconSVG("add-to-basket", "w-4 h-4 aspect-square") : $a9b44c853f7ad42f$var$getIconSVG("email", "w-4 h-4 aspect-square");
      const quickAddLabel = product.available ? (0, $65zHg.escapeHTML)(window.MBF?.strings?.product?.addToCart || "Translation missing: en.product.add_to_cart") : (0, 
      $65zHg.escapeHTML)(window.MBF?.strings?.outOfStock?.notifyShort || "Translation missing: en.product.out_of_stock.notify_short");
      const quickAddMarkup = canQuickAdd ? `<div class="product-card__qs absolute z-2 bottom-0 right-0 text-scheme-links desktop:opacity-0 desktop:pointer-events-none supports-hover:group-hover:opacity-100 transition-opacity supports-hover:group-hover:pointer-events-auto">\n      <ajax-modal data-view="quick-shop" class="no-js:hidden">\n        <a\n          href="${productUrl}"\n          aria-label="${quickAddLabel}"\n          class="flex aria-busy:cursor-wait aria-busy:opacity-50 aria-disabled:pointer-events-none"\n        >\n          <div class="p-2.5 m-3 bg-scheme-background-85 rounded-xs backdrop-blur-2xs tablet:m-2 tablet:p-1">\n            <div class="flex items-center justify-center gap-1.5">\n              <span class="product-card__qs-icon">\n                ${quickAddIcon}\n              </span>\n              <span class="text-sm leading-4 tablet:hidden">\n                ${quickAddLabel}\n              </span>\n            </div>\n          </div>\n        </a>\n      </ajax-modal>\n    </div>` : "";
      const badges = product.metafields?.product_card?.badges?.value || [];
      const soldOutBadgeMarkup = toggleBadges && !product.available ? `<div class="bg-mist text-mulch font-serif text-sm px-2 py-1.5 tracking-n-md leading-md rounded-xs tablet:text-xs">${(0, 
      $65zHg.escapeHTML)(window.MBF?.strings?.soldOut || "Translation missing: en.product.sold_out")}</div>` : "";
      $a9b44c853f7ad42f$var$log("ui", "Product card badge decision", {
        product: $a9b44c853f7ad42f$var$summarizeProduct(product),
        toggleBadges: toggleBadges,
        soldOut: !product.available,
        badgeCount: badges.length,
        badgeLimit: badgeLimit,
        mobileBadgeLimit: mobileBadgeLimit,
        badges: Array.isArray(badges) ? badges.map((badge, index) => ({
          index: index,
          text: badge?.text || "",
          hiddenDesktop: index >= badgeLimit,
          hiddenTablet: index >= mobileBadgeLimit,
          backgroundColour: badge?.background_colour || null,
          textColour: badge?.text_colour || null
        })) : badges
      });
      let badgesMarkup = "";
      if (toggleBadges) {
        if (badges.length > 0) {
          const badgeItems = badges.map((badge, index) => `<div class="font-serif text-sm px-2 py-1.5 tracking-n-md leading-md rounded-xs tablet:text-xs ${index >= badgeLimit ? "hidden" : ""} ${index >= mobileBadgeLimit ? "tablet:hidden" : ""}" style="background-color: ${(0, 
          $65zHg.escapeHTML)(badge.background_colour || "#916C3D")}; color: ${(0, $65zHg.escapeHTML)(badge.text_colour || "#F7F5EC")};">\n              ${(0, 
          $65zHg.escapeHTML)(badge.text || "")}\n            </div>`).join("");
          badgesMarkup = `<div class="pointer-events-none absolute z-20 top-0 left-0 p-3 gap-2 flex flex-wrap tablet:p-2">${soldOutBadgeMarkup}${badgeItems}</div>`;
        } else if (!product.available) badgesMarkup = `<div class="pointer-events-none absolute z-20 top-0 left-0 p-3 gap-2 flex flex-wrap tablet:p-2">${soldOutBadgeMarkup}</div>`;
      }
      const availableVariantsCount = product.variants?.filter(v => v.available).length || 0;
      const showAvailableVariants = variantCount > 1 && availableVariantsCount >= 1 && variantCount !== availableVariantsCount && product.metafields?.custom?.event_type == null;
      const optionsAvailableText = `${availableVariantsCount} ${(0, $65zHg.pluralize)((0, 
      $65zHg.getTranslation)("product.optionsAvailableCount"), availableVariantsCount)}`;
      return `\n    <div class="product-card group relative ${additionalClasses}" data-tagalys-product-id="${product.id}" data-async>\n      <div class="product-card__media relative z-0">\n        <a href="${productUrl}" class="relative block z-1 aspect-9/10 bg-black-10">\n          ${$a9b44c853f7ad42f$export$6c49dedf84602800(images, {
        disableCarousel: disableCarousel,
        disableHoverImage: disableHoverImage
      })}\n        </a>\n        ${badgesMarkup}\n        ${quickAddMarkup}\n      </div>\n\n      <div class="product-card__content">\n        <a href="${productUrl}" class="product-card__meta flex flex-col pt-4 tablet:pt-3.5">\n          <div class="product-card__info">\n            <div class="product-card__title text-scheme-links text-md font-serif leading-md tracking-n-sm tablet:text-base">\n              ${productTitle}\n            </div>\n            <div class="product-card__price text-scheme-links leading-xl tracking-2 mt-1.5 tablet:text-sm">\n              <div class="flex items-center justify-end flex-wrap flex-row-reverse ${discountBadgeMarkup ? "" : "tablet:gap-y-1"}">\n                ${discountBadgeMarkup}\n                ${compareMarkup}\n                <span>\n                  ${priceVaries ? (window.MBF?.strings?.product?.fromPriceHtml || "From {{ price }}").replace("{{ price }}", formattedPriceMin || "") : formattedPrice}\n                </span>\n              </div>\n            </div>\n          </div>\n        </a>\n        <div data-log="availableVariantsCount: ${availableVariantsCount}"></div>\n        ${showAvailableVariants ? `<div class="product-card__variants text-sm leading-xl mt-1.5 text-scheme-text tablet:text-xs">\n          ${optionsAvailableText}\n        </div>\n        ` : ""}\n      </div>\n    </div>\n  `;
    }
    function $a9b44c853f7ad42f$var$trimMoneyZeros(value) {
      return `${value}`.replace(/([.,]00)(?!\d)/, "");
    }
    function $a9b44c853f7ad42f$var$summarizeProduct(product = {}) {
      return {
        id: product.id || null,
        handle: product.handle || null,
        title: product.title || null,
        available: product.available,
        imageCount: product.images?.length || 0,
        variantCount: product.variants?.length || 0
      };
    }
    function $a9b44c853f7ad42f$var$summarizeImage(image = {}) {
      if (!image) return null;
      return {
        src: image.src || null,
        alt: image.alt || null
      };
    }
    function $a9b44c853f7ad42f$var$normalizeGalleryOptions(galleryOptions) {
      if (typeof galleryOptions === "boolean") return {
        disableCarousel: galleryOptions,
        disableHoverImage: false
      };
      return {
        disableCarousel: Boolean(galleryOptions?.disableCarousel),
        disableHoverImage: Boolean(galleryOptions?.disableHoverImage)
      };
    }
    function $a9b44c853f7ad42f$var$getHoverImageReason({imageCount: imageCount, disableHoverImage: disableHoverImage, toggleHoverImage: toggleHoverImage}) {
      if (disableHoverImage) return "disableHoverImage option is true";
      if (imageCount <= 1) return `expected more than 1 image, received ${imageCount}`;
      if (!toggleHoverImage) return "theme setting toggleHoverImage is false";
      return "all hover-image conditions passed";
    }
    function $a9b44c853f7ad42f$var$getDiscountBadgeReason({toggleDiscountBadge: toggleDiscountBadge, priceVaries: priceVaries, cheapestIsDiscounted: cheapestIsDiscounted, metafieldBadge: metafieldBadge}) {
      if (metafieldBadge) return "metafield override (price_discount_badge) is set";
      if (!toggleDiscountBadge) return "discount badge option is disabled for this render";
      if (priceVaries) return "price varies: scanning all variants for max discount";
      if (cheapestIsDiscounted) return "single-variant: cheapest variant is on sale";
      return "cheapest variant is not on sale or compare_at_price is missing/not greater than price";
    }
    function $a9b44c853f7ad42f$var$extractMetafieldValue(metafield) {
      if (metafield == null) return "";
      if (typeof metafield === "string") return metafield.trim();
      if (typeof metafield === "object" && typeof metafield.value === "string") return metafield.value.trim();
      return "";
    }
    function $a9b44c853f7ad42f$var$getQuickAddReasons({toggleQuickAdd: toggleQuickAdd, onOwnPage: onOwnPage, isEventProduct: isEventProduct, hasMultipleOptions: hasMultipleOptions}) {
      const reasons = [];
      if (!toggleQuickAdd) reasons.push("toggleQuickAdd option is false");
      if (onOwnPage) reasons.push("product is on its own page");
      if (isEventProduct) reasons.push("product is an event product");
      if (hasMultipleOptions) reasons.push("product has multiple option groups");
      return reasons.length ? reasons : [ "all quick-add conditions passed" ];
    }
    function $a9b44c853f7ad42f$var$getIconSVG(iconName, className = "") {
      const icons = {
        "add-to-basket": `<svg class="${className}" role="presentation" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n      <path d="M14 6H2l.781 6.248A2 2 0 0 0 4.766 14h6.468a2 2 0 0 0 1.985-1.752L14 6Zm-8.167-.333V3.833a2 2 0 0 1 2-2h.333a2 2 0 0 1 2 2v1.834M8 8v4m0-4v4m2-2H6m4 0H6" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"/>\n    </svg>`,
        email: `<svg class="${className}" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">\n      <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"/>\n      <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"/>\n    </svg>`
      };
      return icons[iconName] || "";
    }
    function $a9b44c853f7ad42f$var$getPlaceholderSVG(className = "") {
      const liquidSvg = window.tagalysConfig?.settings?.placeholder_svg;
      if (liquidSvg) {
        if (className) return liquidSvg.replace(/class="[^"]*"/, `class="${className}"`);
        return liquidSvg;
      }
      return `<svg class="${className}" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.89 14.65c-.27-.3-.6-.5-.97-.58v-1.77c.1-.06.21-.12.3-.2.5-.38.66-1.09.38-1.63-.03-.05-.07-.09-.11-.13C15.42 10.15 15 9.17 15 8c0-2.76-2.24-5-5-5S5 5.24 5 8c0 1.17.42 2.15.5 2.34-.04.04-.08.08-.11.13-.28.54-.12 1.25.38 1.63.1.08.2.14.3.2v1.77c-.37.08-.7.28-.97.58-.32.35-.49.8-.49 1.25 0 .04 0 .08.01.12.01.1.03.19.06.28.18.57.73.9 1.31.9h1.3c.58 0 1.13-.33 1.31-.9.03-.09.05-.18.06-.28.01-.04.01-.08.01-.12 0-.45-.17-.9-.49-1.25zm-5.89-9.65c1.65 0 3 1.35 3 3 0 .73-.25 1.4-.67 1.93-.36.46-.39 1.11-.08 1.61.02.03.04.06.06.09-.08.02-.15.05-.21.12-.32.35-.49.8-.49 1.25 0 .04 0 .08.01.12.01.1.03.19.06.28.18.57.73.9 1.31.9h1.3c.58 0 1.13-.33 1.31-.9.03-.09.05-.18.06-.28.01-.04.01-.08.01-.12 0-.45-.17-.9-.49-1.25-.06-.07-.13-.1-.21-.12.02-.03.04-.06.06-.09.31-.5.28-1.15-.08-1.61-.42-.53-.67-1.2-.67-1.93 0-1.65 1.35-3 3-3z" fill="currentColor" opacity="0.1" /></svg>`;
    }
  });
  parcelRegister("cJzMp", function(module, exports) {
    $parcel$export(module.exports, "createLogger", function() {
      return $94557121a748c06f$export$fe2e61603b61130d;
    });
    $parcel$export(module.exports, "serializeError", function() {
      return $94557121a748c06f$export$46ff38bc6bdea8fb;
    });
    $parcel$export(module.exports, "withDebugReason", function() {
      return $94557121a748c06f$export$4ecc6b6d3cd743de;
    });
    const $94557121a748c06f$var$LS_KEY = "mbf_debug";
    const $94557121a748c06f$var$CATEGORIES = [ "lifecycle", "events", "network", "ui", "animation", "errors" ];
    const $94557121a748c06f$var$CATEGORY_STYLES = {
      lifecycle: "color:#6366f1;font-weight:bold",
      events: "color:#10b981;font-weight:bold",
      network: "color:#3b82f6;font-weight:bold",
      ui: "color:#f59e0b;font-weight:bold",
      animation: "color:#ec4899;font-weight:bold",
      errors: "color:#ef4444;font-weight:bold"
    };
    const $94557121a748c06f$var$FILE_STYLE = "color:#94a3b8;font-style:italic";
    const $94557121a748c06f$var$LABEL_STYLE = "color:#475569";
    const $94557121a748c06f$var$BATCH_WINDOW_MS = 120;
    const $94557121a748c06f$var$GROUPED_LOG_RULES = [ {
      file: "tagalys-helpers",
      category: "ui"
    } ];
    const $94557121a748c06f$var$groupedLogBuffers = new Map;
    const $94557121a748c06f$var$groupedLogTimers = new Map;
    function $94557121a748c06f$var$defaultConfig() {
      const categories = {};
      $94557121a748c06f$var$CATEGORIES.forEach(c => categories[c] = true);
      return {
        enabled: false,
        categories: categories,
        files: {}
      };
    }
    function $94557121a748c06f$var$load() {
      try {
        const raw = localStorage.getItem($94557121a748c06f$var$LS_KEY);
        if (!raw) return $94557121a748c06f$var$defaultConfig();
        const parsed = JSON.parse(raw);
        const cfg = $94557121a748c06f$var$defaultConfig();
        cfg.enabled = !!parsed.enabled;
        if (parsed.categories && typeof parsed.categories === "object") Object.keys(cfg.categories).forEach(k => {
          if (k in parsed.categories) cfg.categories[k] = !!parsed.categories[k];
        });
        if (parsed.files && typeof parsed.files === "object") cfg.files = parsed.files;
        return cfg;
      } catch {
        return $94557121a748c06f$var$defaultConfig();
      }
    }
    function $94557121a748c06f$var$save(cfg) {
      try {
        localStorage.setItem($94557121a748c06f$var$LS_KEY, JSON.stringify(cfg));
      } catch {}
    }
    let $94557121a748c06f$var$_config = typeof window !== "undefined" ? $94557121a748c06f$var$load() : {
      enabled: false
    };
    function $94557121a748c06f$var$_emit(filename, category, args) {
      if (!$94557121a748c06f$var$_config.enabled) return;
      if (!$94557121a748c06f$var$_config.categories[category]) return;
      if ($94557121a748c06f$var$_config.files[filename] === false) return;
      if ($94557121a748c06f$var$shouldGroupLog(filename, category)) {
        $94557121a748c06f$var$queueGroupedLog(filename, category, args);
        return;
      }
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const prefix = `%c[DEBUG] %c[${category}] %c[${filename}]`;
      if (category === "errors") console.error(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args); else console.log(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args);
    }
    function $94557121a748c06f$var$shouldGroupLog(filename, category) {
      return $94557121a748c06f$var$GROUPED_LOG_RULES.some(rule => rule.file === filename && rule.category === category);
    }
    function $94557121a748c06f$var$groupedKey(filename, category) {
      return `${filename}::${category}`;
    }
    function $94557121a748c06f$var$queueGroupedLog(filename, category, args) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key) || [];
      buffer.push(args);
      $94557121a748c06f$var$groupedLogBuffers.set(key, buffer);
      if ($94557121a748c06f$var$groupedLogTimers.has(key)) return;
      const timer = setTimeout(() => {
        $94557121a748c06f$var$groupedLogTimers.delete(key);
        $94557121a748c06f$var$flushGroupedLogs(filename, category);
      }, $94557121a748c06f$var$BATCH_WINDOW_MS);
      $94557121a748c06f$var$groupedLogTimers.set(key, timer);
    }
    function $94557121a748c06f$var$flushGroupedLogs(filename, category) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key);
      if (!buffer || buffer.length === 0) return;
      $94557121a748c06f$var$groupedLogBuffers.delete(key);
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const header = `%c[DEBUG] %c[${category}] %c[${filename}] %c(${buffer.length} logs batched)`;
      console.groupCollapsed(header, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, "color:#64748b");
      buffer.forEach(entryArgs => {
        console.log(...entryArgs);
      });
      console.groupEnd();
    }
    function $94557121a748c06f$var$createRealLogger(filename) {
      return function log(category, ...args) {
        $94557121a748c06f$var$_emit(filename, category, args);
      };
    }
    const $94557121a748c06f$export$fe2e61603b61130d = () => () => {};
    function $94557121a748c06f$export$46ff38bc6bdea8fb(error) {
      if (error instanceof Error) return {
        name: error.name,
        message: error.message,
        stack: error.stack
      };
      return {
        value: error
      };
    }
    function $94557121a748c06f$export$4ecc6b6d3cd743de(reason, details = {}) {
      return {
        reason: reason,
        ...details
      };
    }
    const $94557121a748c06f$export$282d649a8a633ddc = {
      start() {
        $94557121a748c06f$var$_config.enabled = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging enabled. Reload the page for full coverage.", "color:#10b981;font-weight:bold");
        this.status();
      },
      stop() {
        $94557121a748c06f$var$_config.enabled = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging disabled.", "color:#ef4444;font-weight:bold");
      },
      enable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" enabled.`, "color:#10b981");
      },
      disable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" disabled.`, "color:#f59e0b");
      },
      enableFile(file) {
        delete $94557121a748c06f$var$_config.files[file];
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" re-enabled.`, "color:#10b981");
      },
      disableFile(file) {
        $94557121a748c06f$var$_config.files[file] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" disabled.`, "color:#f59e0b");
      },
      status() {
        const categoryRows = $94557121a748c06f$var$CATEGORIES.map(c => ({
          category: c,
          enabled: $94557121a748c06f$var$_config.categories[c] ? "✅" : "❌"
        }));
        const fileRows = Object.entries($94557121a748c06f$var$_config.files).map(([f, v]) => ({
          file: f,
          enabled: v ? "✅" : "❌"
        }));
        console.group("%c[DEBUG] Status", "color:#6366f1;font-weight:bold");
        console.log("Logging:", $94557121a748c06f$var$_config.enabled ? "%c enabled" : "%c disabled", $94557121a748c06f$var$_config.enabled ? "color:#10b981;font-weight:bold" : "color:#ef4444;font-weight:bold");
        console.log("localStorage key:", $94557121a748c06f$var$LS_KEY);
        console.table(categoryRows);
        if (fileRows.length) {
          console.log("File overrides:");
          console.table(fileRows);
        } else console.log("File overrides: none (all files active)");
        console.groupEnd();
      },
      reset() {
        localStorage.removeItem($94557121a748c06f$var$LS_KEY);
        $94557121a748c06f$var$_config = $94557121a748c06f$var$defaultConfig();
        console.log("%c[DEBUG] Settings cleared from localStorage.", "color:#f59e0b;font-weight:bold");
      },
      help() {
        console.group("%c[DEBUG] Available commands", "color:#6366f1;font-weight:bold");
        console.log([ "__debug.start()               — enable all logging", "__debug.stop()                — disable all logging", "__debug.status()              — show current config", '__debug.enable("category")    — enable a category', '__debug.disable("category")   — disable a category', `__debug.enable("…")           — categories: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`, '__debug.enableFile("file")    — un-exclude a file', '__debug.disableFile("file")   — exclude a file from output', "__debug.reset()               — clear all settings from localStorage", "__debug.help()                — show this help" ].join("\n"));
        console.groupEnd();
      }
    };
  });
  parcelRegister("65zHg", function(module, exports) {
    $parcel$export(module.exports, "getTranslation", function() {
      return $0124e2aec3ae0b2d$export$202e99f82f7f0395;
    });
    $parcel$export(module.exports, "pluralize", function() {
      return $0124e2aec3ae0b2d$export$cefb40c9962541b5;
    });
    $parcel$export(module.exports, "interpolate", function() {
      return $0124e2aec3ae0b2d$export$89e29e4ab65e70a9;
    });
    $parcel$export(module.exports, "escapeHTML", function() {
      return $0124e2aec3ae0b2d$export$5dd27816c66fb702;
    });
    $parcel$export(module.exports, "resolveQuery", function() {
      return $0124e2aec3ae0b2d$export$55c0b4ad64fcd6;
    });
    $parcel$export(module.exports, "getValidFilters", function() {
      return $0124e2aec3ae0b2d$export$f88ba4b7479d6747;
    });
    $parcel$export(module.exports, "shouldShowFilters", function() {
      return $0124e2aec3ae0b2d$export$b3e6c7ce956f2053;
    });
    $parcel$export(module.exports, "handleRedirect", function() {
      return $0124e2aec3ae0b2d$export$733e9c9bfa11b30e;
    });
    var $cJzMp = parcelRequire("cJzMp");
    const $0124e2aec3ae0b2d$var$log = (0, $cJzMp.createLogger)("state-utils");
    function $0124e2aec3ae0b2d$export$202e99f82f7f0395(path, fallback) {
      const mbfValue = path.split(".").reduce((acc, key) => acc?.[key], window.MBF?.strings);
      if (mbfValue != null) return mbfValue;
      if (typeof fallback === "object" && fallback !== null) return fallback;
      return fallback === "Missing translation" ? `Translation missing: en.${path}` : fallback ?? `Translation missing: en.${path}`;
    }
    function $0124e2aec3ae0b2d$export$cefb40c9962541b5(forms, count) {
      if (typeof forms === "string") return forms;
      const key = count === 1 ? "one" : "other";
      return forms?.[key] ?? forms?.other ?? "";
    }
    function $0124e2aec3ae0b2d$export$89e29e4ab65e70a9(template, replacements = {}) {
      if (!template) return "";
      const normalizedTemplate = `${template}`.replaceAll("&#39;", "'").replaceAll("&#x27;", "'").replaceAll("&quot;", '"');
      return Object.entries(replacements).reduce((acc, [key, value]) => {
        const safeValue = `${value ?? ""}`;
        return acc.replaceAll(`{{ ${key} }}`, safeValue).replaceAll(`{{${key}}}`, safeValue).replaceAll(`__${key}__`, safeValue).replaceAll(`**${key}**`, safeValue);
      }, normalizedTemplate);
    }
    function $0124e2aec3ae0b2d$export$5dd27816c66fb702(value) {
      return `${value ?? ""}`.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }
    function $0124e2aec3ae0b2d$export$55c0b4ad64fcd6(helpers, query) {
      const urlQuery = new URLSearchParams(window.location.search).get("q");
      return query || helpers?.getQuery?.() || urlQuery || "";
    }
    function $0124e2aec3ae0b2d$export$f88ba4b7479d6747(response) {
      if (!response || !Array.isArray(response.filters)) return [];
      return response.filters.filter(filter => Array.isArray(filter.items) && filter.items.length > 0);
    }
    function $0124e2aec3ae0b2d$export$b3e6c7ce956f2053(component, response) {
      if (component.currentTab !== "products") return false;
      if (!component.query) return false;
      const hasProductResults = response && Array.isArray(response.products) && response.products.length > 0 && (response.total_count ?? 0) > 0;
      if (!hasProductResults) return false;
      const filtersToValidate = component.initialFilters || response?.filters || [];
      const validFilters = $0124e2aec3ae0b2d$export$f88ba4b7479d6747({
        filters: filtersToValidate
      });
      const hasSortOptions = response && Array.isArray(response.sort_options) && response.sort_options.length > 0;
      return validFilters.length > 0 || hasSortOptions;
    }
    function $0124e2aec3ae0b2d$var$buildRedirectTarget(url) {
      const parser = document.createElement("a");
      parser.href = url;
      return (window.Shopify?.routes?.root || "/") + parser.pathname.replace(/^\//, "");
    }
    function $0124e2aec3ae0b2d$export$733e9c9bfa11b30e(helpers, response = null) {
      const helpersRedirected = Boolean(helpers && typeof helpers.isRedirected === "function" && helpers.isRedirected());
      const responseRedirectUrl = response?.redirect_url || null;
      $0124e2aec3ae0b2d$var$log("network", "handleRedirect:eval", {
        hasHelpers: Boolean(helpers),
        helpersRedirected: helpersRedirected,
        hasResponseRedirectUrl: Boolean(responseRedirectUrl),
        responseRedirectUrl: responseRedirectUrl
      });
      if (helpersRedirected) {
        const target = $0124e2aec3ae0b2d$var$buildRedirectTarget(helpers.getRedirectURL());
        $0124e2aec3ae0b2d$var$log("network", "handleRedirect:fire", {
          source: "helpers",
          target: target
        });
        location.replace(target);
        return true;
      }
      if (responseRedirectUrl) {
        const target = $0124e2aec3ae0b2d$var$buildRedirectTarget(responseRedirectUrl);
        $0124e2aec3ae0b2d$var$log("network", "handleRedirect:fire", {
          source: "response",
          target: target
        });
        location.replace(target);
        return true;
      }
      return false;
    }
  });
  var $ezkA5 = parcelRequire("ezkA5");
  var $cJzMp = parcelRequire("cJzMp");
  const $92546df26b4e6577$var$log = (0, $cJzMp.createLogger)("url-state-manager");
  const $92546df26b4e6577$var$RESERVED_KEYS = [ "q", "sort", "page" ];
  class $92546df26b4e6577$export$b011c1f6ae44b5bf {
    static hydrateParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const urlPage = parseInt(urlParams.get("page"), 10);
      const urlSort = urlParams.get("sort");
      const page = urlPage > 0 ? urlPage : null;
      const sort = urlSort || null;
      const filters = {};
      urlParams.forEach((value, key) => {
        if (!$92546df26b4e6577$var$RESERVED_KEYS.includes(key) && value) filters[key] = value.split(",");
      });
      $92546df26b4e6577$var$log("state", "hydrateParams", {
        page: page,
        sort: sort,
        filters: filters
      });
      return {
        page: page,
        sort: sort,
        filters: filters
      };
    }
    static sync(query, sortBy, page, activeFilters, currentTab) {
      const isProducts = currentTab === "products";
      const effectiveSort = isProducts ? sortBy : "trending";
      const effectivePage = isProducts ? page : 1;
      const params = new URLSearchParams;
      if (query) params.set("q", query);
      if (effectiveSort && effectiveSort !== "trending") params.set("sort", effectiveSort);
      if (Number(effectivePage) > 1) params.set("page", `${effectivePage}`);
      Object.entries(activeFilters || {}).forEach(([key, values]) => {
        if (Array.isArray(values) && values.length > 0) params.set(key, values.join(","));
      });
      const searchParams = params.toString();
      const href = `${window.location.pathname}${searchParams ? `?${searchParams}` : ""}`;
      const method = isProducts && Number(effectivePage) !== Number(page) ? "pushState" : "replaceState";
      window.history[method](null, "", href);
      $92546df26b4e6577$var$log("state", "sync", {
        query: query,
        effectiveSort: effectiveSort,
        effectivePage: effectivePage,
        isProducts: isProducts,
        method: method,
        activeFilterCount: Object.keys(activeFilters || {}).filter(k => activeFilters[k]?.length > 0).length
      });
    }
  }
  var $cJzMp = parcelRequire("cJzMp");
  const $0e64f75d8b506542$var$log = (0, $cJzMp.createLogger)("tagalys-client");
  class $0e64f75d8b506542$export$fd6fefded6aba03 {
    isAvailable() {
      return Boolean(window.Tagalys?.APIConnector?.SearchResults?.new);
    }
    fetchProducts(params) {
      return new Promise((resolve, reject) => {
        const instance = this._createSearchInstance(params, (response, helpers) => resolve({
          response: response,
          helpers: helpers
        }), response => reject(response));
        if (!instance) {
          reject(new Error("Tagalys SearchResults SDK not available"));
          return;
        }
        instance.helpers.call();
      });
    }
    fetchSuggestions(params) {
      return new Promise((resolve, reject) => {
        const instance = this._createSuggestionsInstance(params, response => resolve(response), response => reject(response));
        if (!instance) {
          reject(new Error("Tagalys SearchSuggestions SDK not available"));
          return;
        }
        instance.helpers.call();
      });
    }
    fetchAvailability(query, nonProductPerPage, requestCount) {
      const params = this._buildTabAvailabilityParams(query);
      return this.fetchSuggestions(params);
    }
    async fetchWithSkeletonFallback(query, page, perPage, sortBy, filters) {
      const hasUrlFilters = filters && Object.keys(filters).length > 0;
      if (!hasUrlFilters) {
        const params = this._buildSearchParams(query, page, perPage, sortBy, filters);
        return this.fetchProducts(params);
      }
      try {
        const skeletonParams = this._buildSearchParams(query, 1, 1, sortBy, {});
        const skeletonResult = await this.fetchProducts(skeletonParams);
        const initialFilters = skeletonResult.response?.filters ? JSON.parse(JSON.stringify(skeletonResult.response.filters)) : null;
        const filteredParams = this._buildSearchParams(query, page, perPage, sortBy, filters);
        const filteredResult = await this.fetchProducts(filteredParams);
        if (initialFilters) filteredResult.initialFilters = initialFilters;
        return filteredResult;
      } catch {
        const params = this._buildSearchParams(query, page, perPage, sortBy, filters);
        return this.fetchProducts(params);
      }
    }
    _buildSearchParams(query, page, perPage, sortBy, filters = {}) {
      const params = {
        query: query || "",
        page: Math.max(1, Number(page) || 1),
        perPage: Math.max(1, Number(perPage) || 24),
        sort: sortBy || "trending"
      };
      const activeFilters = {};
      Object.keys(filters).forEach(key => {
        if (Array.isArray(filters[key]) && filters[key].length > 0) activeFilters[key] = filters[key];
      });
      if (Object.keys(activeFilters).length > 0) params.filters = activeFilters;
      $0e64f75d8b506542$var$log("network", "buildSearchParams", {
        query: params.query,
        page: params.page,
        perPage: params.perPage,
        sort: params.sort,
        hasFilters: Boolean(params.filters)
      });
      return params;
    }
    _buildSuggestionsParams(query, page, nonProductPerPage, overrideCount, options = {}) {
      const count = Math.max(1, Number(overrideCount ?? nonProductPerPage) || 1);
      const includeSections = options?.includeSections;
      const sectionCounts = options?.sectionCounts;
      const sectionFilter = Array.isArray(includeSections) && includeSections.length > 0 ? new Set(includeSections) : null;
      const hasSectionCounts = Boolean(sectionCounts && typeof sectionCounts === "object");
      const sections = {};
      if (hasSectionCounts) {
        if (sectionCounts.products > 0) sections.products = {
          count: Math.max(0, Number(sectionCounts.products) || 0),
          include: [ "total_count", "items" ]
        };
        if (sectionCounts.articles > 0) sections.articles = {
          count: Math.max(0, Number(sectionCounts.articles) || 0)
        };
        if (sectionCounts.pages > 0) sections.pages = {
          count: Math.max(0, Number(sectionCounts.pages) || 0)
        };
        if (sectionCounts.collections > 0) sections.collections = {
          count: Math.max(0, Number(sectionCounts.collections) || 0)
        };
        return {
          query: query || "",
          suggestions: {
            count: 5
          },
          sections: sections
        };
      }
      sections.products = {
        count: 1,
        include: [ "total_count", "items" ]
      };
      if (!sectionFilter || sectionFilter.has("articles")) sections.articles = {
        count: count
      };
      if (!sectionFilter || sectionFilter.has("pages")) sections.pages = {
        count: count
      };
      if (!sectionFilter || sectionFilter.has("collections")) sections.collections = {
        count: count
      };
      return {
        query: query || "",
        suggestions: {
          count: 5
        },
        sections: sections
      };
    }
    _buildTabAvailabilityParams(query) {
      return {
        query: query || "",
        suggestions: {
          count: 1
        },
        sections: {
          products: {
            count: 1,
            include: [ "total_count", "items" ]
          },
          articles: {
            count: 1
          },
          pages: {
            count: 1
          },
          collections: {
            count: 1
          }
        }
      };
    }
    _createSearchInstance(params, onSuccess, onFailure) {
      if (!window.Tagalys?.APIConnector?.SearchResults?.new) {
        $0e64f75d8b506542$var$log("errors", "Tagalys.APIConnector.SearchResults.new is not available");
        return null;
      }
      try {
        return window.Tagalys.APIConnector.SearchResults.new({
          params: params,
          onSuccess: onSuccess,
          onFailure: onFailure
        });
      } catch (error) {
        $0e64f75d8b506542$var$log("errors", "Failed to create SearchResults instance", error);
        return null;
      }
    }
    _createSuggestionsInstance(params, onSuccess, onFailure) {
      if (!window.Tagalys?.APIConnector?.SearchSuggestions?.new) {
        $0e64f75d8b506542$var$log("errors", "Tagalys.APIConnector.SearchSuggestions.new is not available");
        return null;
      }
      try {
        return window.Tagalys.APIConnector.SearchSuggestions.new({
          params: params,
          onSuccess: onSuccess,
          onFailure: onFailure
        });
      } catch (error) {
        $0e64f75d8b506542$var$log("errors", "Failed to create SearchSuggestions instance", error);
        return null;
      }
    }
  }
  var $65zHg = parcelRequire("65zHg");
  var $65zHg = parcelRequire("65zHg");
  var $cJzMp = parcelRequire("cJzMp");
  const $90306004c34c4e6b$var$log = (0, $cJzMp.createLogger)("filter-templates");
  function $90306004c34c4e6b$export$8b89b3d2b9d4a92d(component, response, activeFiltersHtml, hasValidFilters, totalCount, sortControlHTML) {
    return `\n    <form class="flex flex-col px-offset" id="${component.formId}" action="${window.location.pathname}" method="get" novalidate>\n      <div class="flex w-full gap-4 justify-between py-3 border-y border-scheme-border items-center min-h-14.5 tablet:min-h-12 tablet:py-2">\n        <div class="flex flex-1 items-center gap-5">\n          ${hasValidFilters ? `\n            <div class="flex tablet:hidden items-center gap-5 group/filters">\n              ${$90306004c34c4e6b$export$8563b221825a789e(component, response)}\n            </div>\n            <div>\n              <filter-trigger>\n                <button\n                  type="button"\n                  class="relative btn-text items-center cursor-pointer mb-0 desktop:text-base supports-hover:hover:opacity-80 text-scheme-links"\n                >\n                  <span class="desktop:hidden">${(0, 
    $65zHg.getTranslation)("collection.filter.drawer.trigger", "Missing translation")}</span>\n                  <span class="hidden desktop:inline">${(0, 
    $65zHg.getTranslation)("collection.filter.all", "Missing translation")}</span>\n                </button>\n              </filter-trigger>\n            </div>\n          ` : ""}\n        </div>\n        <div class="flex gap-5 justify-between items-center shrink-0">\n          <div class="flex items-center gap-1 order-1 tablet:order-2 supports-hover:hover:opacity-80 text-scheme-links">\n            <label class="cursor-pointer btn-text mb-0 desktop:text-base" for="product-grid-layout-three" data-layout-five-toggle>\n              ${(0, 
    $65zHg.escapeHTML)(component.columnsThreeLabel)}\n            </label>\n            <label class="hidden cursor-pointer btn-text mb-0 desktop:text-base" for="product-grid-layout-five" data-layout-three-toggle>\n              ${(0, 
    $65zHg.escapeHTML)(component.columnsFiveLabel)}\n            </label>\n          </div>\n          <div class="order-2 tablet:order-1">\n            ${sortControlHTML}\n          </div>\n        </div>\n      </div>\n      ${activeFiltersHtml ? `<div\n                    class="flex gap-2.5 overflow-x-auto scrollbar-none -mx-offset px-offset scroll-px-offset py-4 tablet:py-3 items-center"\n                    data-facet="${component.formId}-active-filters-mobile"\n                    data-active-filters-bar\n                  >\n                    <button data-reset data-clear-filters class="bg-clay rounded-sm px-2 py-0.5 shrink-0 text-mulch text-xs font-sans desktop:text-sm whitespace-nowrap">${(0, 
    $65zHg.getTranslation)("collection.filter.reset_all", "Missing translation")}</button>\n                    ${activeFiltersHtml}\n                  </div>` : ""}\n    </form>\n  `;
  }
  function $90306004c34c4e6b$export$8563b221825a789e(component, response) {
    const allFilters = response.filters || [];
    const withItems = allFilters.filter(filter => Array.isArray(filter.items) && filter.items.length > 0);
    const sliced = withItems.slice(0, 4);
    return sliced.map(filter => $90306004c34c4e6b$export$3cecf306c11ec6aa(component, filter, "desktop")).join("");
  }
  function $90306004c34c4e6b$export$96b8e0ddaa29c922(component, response, activeFiltersHtml, totalCount) {
    const visibleFilters = (response.filters || []).filter(filter => Array.isArray(filter.items) && filter.items.length > 0);
    const hasActiveFilters = Object.values(component.filters || {}).some(values => Array.isArray(values) && values.length > 0);
    const applyText = (0, $65zHg.interpolate)((0, $65zHg.pluralize)((0, $65zHg.getTranslation)("search.filterApply", {
      one: "",
      other: ""
    }), totalCount), {
      count: totalCount
    });
    return `\n    <div class="contents">\n      <details-disclosure data-scroll-lock class="has-closing-animation">\n        <details id="filter-drawer" class="group">\n          <summary class="hidden"></summary>\n          <div class="fixed inset-0 z-100 flex justify-end animate-slide-in-right">\n            <div class="drawer-underlay fixed inset-0 bg-mulch-30 backdrop-blur-[2px] opacity-0 group-open:opacity-100 left-[-100vw] transition-opacity" data-close></div>\n            <div class="relative h-full w-drawer [--columns:4] [--offsets:1] tablet:w-full bg-scheme-background shadow-2xl flex flex-col" data-filter-drawer role="dialog" aria-modal="true" aria-labelledby="filter-drawer-title">\n              <div class="relative flex justify-between items-end tablet:pb-3 pb-5.5 px-offset min-h-[76px] tablet:min-h-[56px]">\n                <div class="text-scheme-links font-normal font-sans" data-title>\n                  <span id="filter-drawer-title" class="text-base tablet:text-sm">${(0, 
    $65zHg.getTranslation)("collection.filter.plural", "Missing translation")}</span>\n                </div>\n                <div class="text-base tablet:text-sm text-scheme-links cursor-pointer font-normal font-sans" data-close>\n                  ${(0, 
    $65zHg.getTranslation)("general.close", "Missing translation")}\n                </div>\n                <div class="absolute bottom-0 left-offset right-offset h-px bg-scheme-border"></div>\n              </div>\n              <div class="overflow-y-scroll h-full w-full flex flex-col scrollbar-none" data-drawer-body>\n                <div class="px-offset flex flex-col py-6 gap-4 desktop:gap-5">\n                  ${activeFiltersHtml ? `<div class="flex gap-2 flex-wrap" data-facet="${component.formId}-active-filters-drawer" data-drawer-active-filters>${activeFiltersHtml}</div>` : ""}\n                  ${visibleFilters.map((filter, index) => $90306004c34c4e6b$export$3cecf306c11ec6aa(component, filter, "drawer", {
      isLast: index === visibleFilters.length - 1
    })).join("")}\n                </div>\n              </div>\n              <div class="px-offset py-4 flex gap-2 justify-end border-t border-scheme-border" data-drawer-footer>\n                <button class="flex-1 leading-4 max-w-[145px] desktop:max-w-1/2 bg-clay text-scheme-text py-4 rounded-sm transition-colors supports-hover:hover:opacity-80 disabled:opacity-50" type="button" data-reset data-clear-filters ${hasActiveFilters ? "" : "disabled"}>\n                  ${(0, 
    $65zHg.getTranslation)("collection.filter.reset_all", "Missing translation")}\n                </button>\n                <button class="flex-1 leading-4 max-w-[205px] desktop:max-w-1/2 bg-lichen text-chalk py-4 rounded-sm transition-colors supports-hover:hover:opacity-90" type="button" data-close>\n                  ${applyText}\n                </button>\n              </div>\n            </div>\n          </div>\n        </details>\n      </details-disclosure>\n    </div>\n  `;
  }
  function $90306004c34c4e6b$export$3cecf306c11ec6aa(component, filter, context, options = {}) {
    const allItems = filter.items || [];
    if (!allItems.length) return "";
    const selectedCount = component.filters[filter.id]?.length || 0;
    const filterLabel = selectedCount > 0 ? `${(0, $65zHg.escapeHTML)(filter.label)} (${selectedCount})` : (0, 
    $65zHg.escapeHTML)(filter.label);
    if (context === "desktop") return `\n      <details-disclosure class="relative">\n        <details class="group" name="filter-accordion">\n          <summary class="cursor-pointer" aria-expanded="false">\n            <div class="flex items-center gap-2">\n              <div\n                class="text-heading-2xs text-scheme-links group-open:text-scheme-links! transition-colors hover:text-scheme-text group-has-open/filters:text-scheme-text"\n                data-facet="${component.formId}-label-${filter.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}"\n              >${filterLabel}</div>\n              <svg\n                class="h-1.75 w-auto text-scheme-links transition-all group-open:rotate-180 group-open:text-scheme-links"\n                role="presentation"\n                xmlns="http://www.w3.org/2000/svg"\n                width="14"\n                height="8"\n                viewBox="0 0 14 8"\n                fill="none"\n              >\n                <path d="M12.9197 0.424266L7.0253 6.31857C6.83003 6.51383 6.51345 6.51383 6.31819 6.31857L0.423828 0.424267" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"></path>\n              </svg>\n            </div>\n          </summary>\n          <filter-menu\n            aria-label="${(0, 
    $65zHg.escapeHTML)(filter.label)} filters"\n            role="group"\n            class="filter-dropdown absolute top-full left-0 bg-scheme-background border border-t-mulch border-scheme-border w-grid [--columns:4.8] min-w-79 max-h-100 overflow-y-auto mt-4 px-3 py-5 flex flex-col gap-2.5"\n          >\n            <div data-filter-menu>\n              <div class="flex flex-col gap-3 items-start empty:hidden" data-facet="${component.formId}-${filter.id}">\n                ${allItems.map(item => $90306004c34c4e6b$export$25fd475dd8c687f5(component, filter, item, "desktop")).join("")}\n              </div>\n            </div>\n          </filter-menu>\n        </details>\n      </details-disclosure>\n    `;
    return `\n    <details class="pb-4 flex flex-col ${options.isLast ? "" : "border-b border-scheme-border"} group/accordion">\n      <summary class="text-button text-scheme-links cursor-pointer flex justify-between items-center group-open/accordion:mb-5">\n        <span class="h4 font-serif" data-facet="drawer-${component.formId}-label-${filter.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}">${filterLabel}</span>\n        <div class="relative size-5">\n          <div class="plus-icon absolute inset-0 transition-all duration-200 group-open/accordion:opacity-0 group-open/accordion:rotate-180">\n            <svg class="size-5" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">\n              <path d="M10 17.143V2.857m0 14.286V2.857M2.857 10h14.286M2.857 10h14.286" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"></path>\n            </svg>\n          </div>\n          <div class="minus-icon absolute inset-0 opacity-0 rotate-180 transition-all duration-200 group-open/accordion:opacity-100 group-open/accordion:rotate-0">\n            <svg class="size-5" role="presentation" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M2.857 10h14.286M2.857 10h14.286" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"></path>\n            </svg>\n          </div>\n        </div>\n      </summary>\n      <div class="drawer-accordion-content" data-facet="drawer-${component.formId}-${filter.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}">\n        <div>\n          <div class="flex flex-col gap-3.5">\n            ${allItems.map(item => $90306004c34c4e6b$export$25fd475dd8c687f5(component, filter, item, "drawer")).join("")}\n          </div>\n        </div>\n      </div>\n    </details>\n  `;
  }
  function $90306004c34c4e6b$var$parseSwatchColours(item) {
    if (typeof item.swatch !== "string" || !item.swatch) return null;
    try {
      const {colours: colours} = JSON.parse(item.swatch);
      const parsed = typeof colours === "string" ? JSON.parse(colours) : colours;
      return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
    } catch {
      return null;
    }
  }
  function $90306004c34c4e6b$var$renderSwatchColoursHTML(colours) {
    const total = colours.length;
    return `<div class="flex items-center -space-x-1.5 isolate shrink-0">${colours.map((color, i) => `<span class="size-4 rounded-full" style="background-color: ${(0, 
    $65zHg.escapeHTML)(color)}; z-index: ${total - i};"></span>`).join("")}</div>`;
  }
  function $90306004c34c4e6b$export$25fd475dd8c687f5(component, filter, item, context) {
    const isChecked = component.filters[filter.id] && component.filters[filter.id].includes(item.id);
    const inputId = `Filter-tagalys-${filter.id}-${item.id}-${context}`;
    const isDisabled = Number(item.count) === 0 && !isChecked;
    const swatchColours = $90306004c34c4e6b$var$parseSwatchColours(item);
    return `\n    <div class="cursor-pointer self-stretch ${isDisabled ? "opacity-50 pointer-events-none" : ""}">\n      <input\n        type="checkbox"\n        value="${(0, 
    $65zHg.escapeHTML)(item.id)}"\n        id="${inputId}"\n        class="sr-only peer"\n        data-filter-key="${(0, 
    $65zHg.escapeHTML)(filter.id)}"\n        data-filter-value="${(0, $65zHg.escapeHTML)(item.id)}"\n        data-context="${(0, 
    $65zHg.escapeHTML)(context)}"\n        autocomplete="off"\n        ${isChecked ? "checked" : ""}\n        ${isDisabled ? "disabled" : ""}\n      >\n      <label\n        data-role="button"\n        data-button\n        tabindex="0"\n        for="${inputId}"\n        class="group/filter flex items-center flex-row-reverse gap-2.5 justify-end focus:outline-none cursor-pointer py-1.75 -my-1.75 peer-checked:[&_[data-swatch]]:bg-scheme-links"\n      >\n        <span class="text-md font-serif flex items-center gap-2.5 text-scheme-links w-full ${context === "desktop" ? "whitespace-nowrap" : ""}">\n          ${swatchColours ? $90306004c34c4e6b$var$renderSwatchColoursHTML(swatchColours) : ""}\n          ${(0, 
    $65zHg.escapeHTML)(item.label)}\n        </span>\n        <span data-swatch class="relative transition-all shrink-0 inline-block size-2.5 m-1 outline outline-1 outline-offset-2 outline-scheme-links rounded-full group-hover/filter:bg-scheme-links peer-checked:bg-scheme-links"></span>\n      </label>\n    </div>\n  `;
  }
  function $90306004c34c4e6b$export$9e54772dd784e49c(filterKey, filterValue, label) {
    return `\n    <button\n      type="button"\n      class="bg-green cursor-pointer text-chalk whitespace-nowrap flex items-center gap-1.5 px-2 py-0.5 rounded-xs text-xs desktop:text-sm transition-opacity supports-hover:hover:opacity-80"\n      data-remove-filter="${filterKey}"\n      data-filter-value="${filterValue}"\n    >\n      ${(0, 
    $65zHg.escapeHTML)(label)}\n      <svg class="pointer-events-none size-2.5 min-w-2.5" role="presentation" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">\n        <path d="m12.344 2.656-9.688 9.688m0-9.688 9.688 9.688" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"></path>\n      </svg>\n    </button>\n  `;
  }
  function $90306004c34c4e6b$export$926ca04b33925026(component, response, activeFiltersHtml) {
    const visibleFilters = (response.filters || []).filter(filter => Array.isArray(filter.items) && filter.items.length > 0);
    return `\n    <div class="px-offset flex flex-col py-6 gap-4 desktop:gap-5">\n      ${activeFiltersHtml ? `<div class="flex gap-2 flex-wrap" data-facet="${component.formId}-active-filters-drawer" data-drawer-active-filters>${activeFiltersHtml}</div>` : ""}\n      ${visibleFilters.map((filter, index) => $90306004c34c4e6b$export$3cecf306c11ec6aa(component, filter, "drawer", {
      isLast: index === visibleFilters.length - 1
    })).join("")}\n    </div>\n  `;
  }
  function $90306004c34c4e6b$export$4a530a39eb879b5(component, totalCount, hasActiveFilters) {
    const applyText = (0, $65zHg.interpolate)((0, $65zHg.pluralize)((0, $65zHg.getTranslation)("search.filterApply", {
      one: "",
      other: ""
    }), totalCount), {
      count: totalCount
    });
    return `\n    <button class="flex-1 leading-4 max-w-[145px] desktop:max-w-1/2 bg-clay text-scheme-text py-4 rounded-sm transition-colors supports-hover:hover:opacity-80 disabled:opacity-50" type="button" data-reset data-clear-filters ${hasActiveFilters ? "" : "disabled"}>\n      ${(0, 
    $65zHg.getTranslation)("collection.filter.reset_all", "Missing translation")}\n    </button>\n    <button class="flex-1 leading-4 max-w-[205px] desktop:max-w-1/2 bg-lichen text-chalk py-4 rounded-sm transition-colors supports-hover:hover:opacity-90" type="button" data-close>\n      ${applyText}\n    </button>\n  `;
  }
  var $cJzMp = parcelRequire("cJzMp");
  const $4f98279e176cab87$var$log = (0, $cJzMp.createLogger)("filter-manager");
  class $4f98279e176cab87$export$4c85e4ca0d95642f {
    constructor(component, containerSelector) {
      this.component = component;
      this.containerSelector = containerSelector;
      this.activeFilters = {};
      this._filtersRendered = false;
      this._sortControlRenderer = null;
      this._bindEvents();
    }
    setSortControlRenderer(renderer) {
      this._sortControlRenderer = renderer;
    }
    hydrate(initialFilters) {
      this.activeFilters = {
        ...initialFilters
      };
      $4f98279e176cab87$var$log("state", "hydrate", {
        filters: this.activeFilters
      });
    }
    getApiPayload() {
      const payload = {};
      Object.keys(this.activeFilters).forEach(key => {
        if (Array.isArray(this.activeFilters[key]) && this.activeFilters[key].length > 0) payload[key] = [ ...this.activeFilters[key] ];
      });
      return payload;
    }
    render(response, totalCount) {
      const filtersContainer = this.component.querySelector(this.containerSelector);
      if (!filtersContainer) return;
      if (response) {
        this.component.lastProductResponse = response;
        if (!this.component.initialFilters && response.filters?.length) this.component.initialFilters = JSON.parse(JSON.stringify(response.filters));
      }
      const showFilters = (0, $65zHg.shouldShowFilters)(this.component, this.component.lastProductResponse);
      if (!showFilters) {
        filtersContainer.classList.add("hidden");
        return;
      }
      filtersContainer.classList.remove("hidden");
      const mergedFilters = this._mergeSkeletonWithLiveCounts(response?.filters || []);
      const responseWithMerged = {
        ...response,
        filters: mergedFilters
      };
      const validFilters = (0, $65zHg.getValidFilters)(responseWithMerged);
      const responseWithValidFilters = {
        ...response,
        filters: validFilters
      };
      const activeFiltersHtml = this._buildActiveFiltersHTML(validFilters);
      const hasValidFilters = validFilters.length > 0;
      const effectiveTotalCount = totalCount ?? this.component.lastProductResponse?.total_count ?? 0;
      const sortHTML = this._sortControlRenderer ? this._sortControlRenderer(this.component, responseWithValidFilters) : "";
      if (this._filtersRendered) {
        this._updateFilters(filtersContainer, responseWithValidFilters, activeFiltersHtml, hasValidFilters, effectiveTotalCount, sortHTML);
        return;
      }
      this._filtersRendered = true;
      const barHTML = (0, $90306004c34c4e6b$export$8b89b3d2b9d4a92d)(this.component, responseWithValidFilters, activeFiltersHtml, hasValidFilters, effectiveTotalCount, sortHTML);
      filtersContainer.innerHTML = `\n      <div class="product-grid__filters" data-filters-bar>\n        ${barHTML}\n      </div>\n      ${hasValidFilters ? `<div data-filter-drawer-wrapper>${(0, 
      $90306004c34c4e6b$export$96b8e0ddaa29c922)(this.component, responseWithValidFilters, activeFiltersHtml, effectiveTotalCount)}</div>` : ""}\n    `;
      $4f98279e176cab87$var$log("ui", "filters:render:complete", {
        hasValidFilters: hasValidFilters,
        activeFilterButtonsCount: (activeFiltersHtml.match(/data-remove-filter/g) || []).length
      });
    }
    _mergeSkeletonWithLiveCounts(liveFilters) {
      if (!this.component.initialFilters) return liveFilters;
      return this.component.initialFilters.map(initialFilter => {
        const currentFilter = liveFilters.find(f => f.id === initialFilter.id);
        return {
          ...initialFilter,
          items: (initialFilter.items || []).map(initialItem => {
            const currentItem = currentFilter?.items?.find(i => i.id === initialItem.id);
            return {
              ...initialItem,
              count: currentItem ? currentItem.count : 0
            };
          })
        };
      });
    }
    _toggleFilter(key, value, isChecked) {
      if (isChecked) {
        const current = this.activeFilters[key] || [];
        if (!current.includes(value)) this.activeFilters[key] = [ ...current, value ];
      } else {
        const current = this.activeFilters[key] || [];
        this.activeFilters[key] = current.filter(v => v !== value);
        if (this.activeFilters[key].length === 0) delete this.activeFilters[key];
      }
      this.component.filters = this.activeFilters;
    }
    _clearAllFilters() {
      this.activeFilters = {};
      this.component.filters = {};
    }
    _removeFilter(key, value) {
      if (this.activeFilters[key]) {
        this.activeFilters[key] = this.activeFilters[key].filter(v => v !== value);
        if (this.activeFilters[key].length === 0) delete this.activeFilters[key];
      }
      this.component.filters = this.activeFilters;
    }
    _dispatchStateChange(detail = {}) {
      this.component.dispatchEvent(new CustomEvent("tagalys:filters-updated", {
        detail: {
          filters: this.getApiPayload(),
          ...detail
        },
        bubbles: true
      }));
    }
    _buildActiveFiltersHTML(validFilters) {
      let html = "";
      Object.keys(this.activeFilters).forEach(filterKey => {
        if (this.activeFilters[filterKey] && this.activeFilters[filterKey].length > 0) this.activeFilters[filterKey].forEach(filterValue => {
          const filter = validFilters.find(f => f.id === filterKey);
          if (!filter) return;
          const item = filter.items?.find(i => i.id === filterValue);
          if (!item) return;
          html += (0, $90306004c34c4e6b$export$9e54772dd784e49c)(filterKey, filterValue, item.label || filterValue);
        });
      });
      return html;
    }
    _updateFilters(filtersContainer, response, activeFiltersHtml, hasValidFilters, totalCount, sortHTML) {
      const filtersBar = filtersContainer.querySelector("[data-filters-bar]");
      if (filtersBar) filtersBar.innerHTML = (0, $90306004c34c4e6b$export$8b89b3d2b9d4a92d)(this.component, response, activeFiltersHtml, hasValidFilters, totalCount, sortHTML);
      const drawerBody = filtersContainer.querySelector("[data-drawer-body]");
      if (drawerBody) drawerBody.innerHTML = (0, $90306004c34c4e6b$export$926ca04b33925026)(this.component, response, activeFiltersHtml);
      const drawerFooter = filtersContainer.querySelector("[data-drawer-footer]");
      if (drawerFooter) {
        const hasActiveFilters = Object.values(this.activeFilters).some(values => Array.isArray(values) && values.length > 0);
        drawerFooter.innerHTML = (0, $90306004c34c4e6b$export$4a530a39eb879b5)(this.component, totalCount, hasActiveFilters);
      }
      $4f98279e176cab87$var$log("ui", "filters:update:complete", {
        hasValidFilters: hasValidFilters,
        totalCount: totalCount
      });
    }
    _bindEvents() {
      const handler = event => {
        this._handleDomEvent(event);
      };
      document.addEventListener("change", handler);
      document.addEventListener("click", handler);
    }
    _handleDomEvent(event) {
      const target = event.target;
      const container = this.component.querySelector(this.containerSelector);
      if (!container || !container.contains(target)) return;
      if (target.matches("[data-sort-selector]") && event.type === "change") {
        this.component.updateSort?.(target.value);
        return;
      }
      if (target.matches('input[type="checkbox"][data-filter-key]') && event.type === "change") {
        const filterKey = target.dataset.filterKey;
        const filterValue = target.dataset.filterValue;
        const checked = target.checked;
        this._syncCheckboxes(filterKey, filterValue, checked);
        this._toggleFilter(filterKey, filterValue, checked);
        this._dispatchStateChange();
        return;
      }
      const removeButton = target.closest("[data-remove-filter]");
      if (removeButton && event.type === "click") {
        event.preventDefault();
        this._removeFilter(removeButton.dataset.removeFilter, removeButton.dataset.filterValue);
        this._dispatchStateChange();
        return;
      }
      const clearButton = target.closest("[data-clear-filters]");
      if (clearButton && event.type === "click") {
        event.preventDefault();
        this._clearAllFilters();
        this._dispatchStateChange();
        return;
      }
      const filterTrigger = target.closest("filter-trigger button");
      if (filterTrigger && event.type === "click") {
        const drawer = container.querySelector("#filter-drawer");
        if (drawer) drawer.setAttribute("open", "");
        return;
      }
    }
    _syncCheckboxes(filterKey, filterValue, checked) {
      const container = this.component.querySelector(this.containerSelector);
      if (!container) return;
      container.querySelectorAll('input[type="checkbox"][data-filter-key][data-filter-value]').forEach(input => {
        if (input.dataset.filterKey === filterKey && input.dataset.filterValue === filterValue) input.checked = checked;
      });
    }
  }
  var $65zHg = parcelRequire("65zHg");
  var $cJzMp = parcelRequire("cJzMp");
  const $dd709126808195a9$var$log = (0, $cJzMp.createLogger)("pagination-manager");
  class $dd709126808195a9$export$765f97f01dfc5b0 {
    constructor(component) {
      this.component = component;
    }
    renderPagination(totalCount, container) {
      const totalPages = Math.ceil(totalCount / this.component.perPage);
      if (totalPages <= 1) {
        container.innerHTML = "";
        return;
      }
      const current = Math.min(this.component.lastLoadedPage * this.component.perPage, totalCount);
      const showNext = this.component.lastLoadedPage < totalPages;
      container.innerHTML = `\n      <div class="flex flex-col items-center gap-4 tablet:w-full">\n        ${showNext ? `<button type="button" class="btn btn--primary min-w-[350px] [--columns:3] tablet:min-w-0 tablet:w-full py-4" data-page="${this.component.lastLoadedPage + 1}" data-load-more-products>${(0, 
      $65zHg.getTranslation)("collection.pagination.load_more", "Missing translation")}</button>` : ""}\n        <div class="text-sm text-center leading-xl tablet:w-full">${(0, 
      $65zHg.interpolate)((0, $65zHg.getTranslation)("collection.pagination.status", "Missing translation"), {
        current: current,
        total: totalCount
      })}</div>\n      </div>\n    `;
      const loadMore = container.querySelector("[data-load-more-products]");
      if (!loadMore) return;
      loadMore.addEventListener("click", () => {
        const page = parseInt(loadMore.dataset.page, 10);
        if (Number.isNaN(page)) return;
        this.component.dispatchEvent(new CustomEvent("tagalys:page-change", {
          detail: {
            requestedPage: page,
            direction: "next"
          }
        }));
      });
    }
    renderLoadPrevious(totalPages) {
      const existing = this.component.querySelector("[data-pagination-previous]");
      if (existing) existing.remove();
      if (this.component.currentTab !== "products") return;
      if (this.component.firstLoadedPage <= 1) return;
      if (totalPages <= 1) return;
      const resultsContainer = this.component.querySelector("[data-search-results]");
      if (!resultsContainer) return;
      const wrapper = document.createElement("div");
      wrapper.setAttribute("data-pagination-previous", "");
      wrapper.className = "self-center col-span-full flex justify-center py-4";
      wrapper.innerHTML = `\n      <button type="button" class="btn btn--secondary" data-load-previous-products data-page="${this.component.firstLoadedPage - 1}">\n        ${(0, 
      $65zHg.escapeHTML)((0, $65zHg.getTranslation)("collection.pagination.load_previous", "Missing translation"))}\n      </button>\n    `;
      resultsContainer.insertAdjacentElement("beforebegin", wrapper);
      const button = wrapper.querySelector("[data-load-previous-products]");
      if (!button) return;
      button.addEventListener("click", () => {
        const page = parseInt(button.dataset.page, 10);
        if (Number.isNaN(page)) return;
        this.component.dispatchEvent(new CustomEvent("tagalys:page-change", {
          detail: {
            requestedPage: page,
            direction: "previous"
          }
        }));
      });
    }
    setLoadingState(type, isLoading) {
      const nextButton = this.component.querySelector("[data-load-more-products]");
      const previousButton = this.component.querySelector("[data-load-previous-products]");
      const target = type === "previous" ? previousButton : nextButton;
      const resultsContainer = this.component.querySelector("[data-search-results]");
      if (!target) return;
      if (isLoading) {
        target.dataset.originalText = target.textContent || "";
        target.disabled = true;
        target.setAttribute("aria-disabled", "true");
        target.classList.add("opacity-50", "cursor-wait");
        target.textContent = (0, $65zHg.getTranslation)("general.loading", "Missing translation");
        if (resultsContainer) resultsContainer.setAttribute("aria-busy", "true");
        return;
      }
      target.disabled = false;
      target.removeAttribute("aria-disabled");
      target.classList.remove("opacity-50", "cursor-wait");
      if (target.dataset.originalText) target.textContent = target.dataset.originalText;
      if (resultsContainer) resultsContainer.removeAttribute("aria-busy");
    }
    getNonProductVisibleCountForStep(step) {
      const safeStep = Math.max(1, Number(step) || 1);
      return Math.max(1, this.component.nonProductPerPage * safeStep);
    }
    getNonProductRequestCountForStep(step) {
      const safeStep = Math.max(1, Number(step) || 1);
      return Math.max(1, (this.component.nonProductPerPage + 1) * safeStep);
    }
    getNonProductStep(tabName) {
      if (tabName === "products") return 1;
      const step = Number(this.component.nonProductStepByTab[tabName]);
      return Number.isFinite(step) && step > 0 ? step : 1;
    }
    setNonProductStep(tabName, step) {
      if (!tabName || tabName === "products") return;
      const previousStep = this.component.nonProductStepByTab[tabName];
      const nextStep = Math.max(1, Number(step) || 1);
      this.component.nonProductStepByTab[tabName] = nextStep;
      $dd709126808195a9$var$log("events", "SearchSuggestions:step:set", {
        tab: tabName,
        previousStep: Number.isFinite(Number(previousStep)) ? Number(previousStep) : null,
        nextStep: nextStep
      });
    }
    setNonProductStepForVisibleCount(tabName, visibleCount) {
      if (!tabName || tabName === "products") return;
      const safeVisibleCount = Math.max(1, Number(visibleCount) || 1);
      const derivedStep = Math.max(1, Math.ceil(safeVisibleCount / this.component.nonProductPerPage));
      $dd709126808195a9$var$log("events", "SearchSuggestions:step:derive-from-visible", {
        tab: tabName,
        visibleCount: safeVisibleCount,
        nonProductPerPage: this.component.nonProductPerPage,
        derivedStep: derivedStep
      });
      this.setNonProductStep(tabName, derivedStep);
    }
  }
  var $65zHg = parcelRequire("65zHg");
  var $cJzMp = parcelRequire("cJzMp");
  const $6b0a22f9b1f3d0ea$var$log = (0, $cJzMp.createLogger)("tab-manager");
  const $6b0a22f9b1f3d0ea$var$ACTIVE_BUTTON_CLASSES = [ "bg-btn-p-bg-h", "border-btn-p-b-h", "text-btn-p-t-h" ];
  const $6b0a22f9b1f3d0ea$var$SECTION_BY_TAB = {
    articles: "articles",
    categories: "collections",
    pages: "pages"
  };
  const $6b0a22f9b1f3d0ea$export$13b3d12a3f56b44e = [ "products", "articles", "categories", "pages" ];
  function $6b0a22f9b1f3d0ea$var$renderPlaintextDivider() {
    return `\n    <svg\n      class="w-full h-auto text-scheme-border"\n      xmlns="http://www.w3.org/2000/svg"\n      width="358"\n      height="4"\n      viewBox="0 0 358 4"\n      fill="none"\n      role="presentation"\n      aria-hidden="true"\n      focusable="false"\n    >\n      <path d="M0.00146484 0.5C0.308038 0.5 31.4006 2.50054 116.357 1.06878C202.345 -0.380381 269.497 3.56551 305.065 3.49911C318.784 3.43271 323.711 3.29992 331.07 3.2315C338.428 3.16309 348.069 3.16309 358.001 3.16309" stroke="currentColor"/>\n    </svg>\n  `;
  }
  class $6b0a22f9b1f3d0ea$export$59220c853884db6b {
    constructor(component) {
      this.component = component;
    }
    initTabs() {
      this._updateTabButtons(this.component.currentTab);
      this.component.querySelectorAll("[data-tab]").forEach(button => {
        button.addEventListener("click", () => {
          const tab = button.dataset.tab;
          if (!tab || tab === this.component.currentTab) return;
          this.switchTab(tab);
        });
      });
      this.component.querySelector("[data-search-tabs]")?.addEventListener("keydown", e => {
        const tabs = Array.from(this.component.querySelectorAll("[data-tab]:not([hidden])"));
        const currentIndex = tabs.indexOf(e.target);
        if (currentIndex === -1) return;
        let nextIndex = -1;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") nextIndex = (currentIndex + 1) % tabs.length; else if (e.key === "ArrowLeft" || e.key === "ArrowUp") nextIndex = (currentIndex - 1 + tabs.length) % tabs.length; else if (e.key === "Home") nextIndex = 0; else if (e.key === "End") nextIndex = tabs.length - 1;
        if (nextIndex !== -1) {
          e.preventDefault();
          tabs[nextIndex].focus();
          const tab = tabs[nextIndex].dataset.tab;
          if (tab && tab !== this.component.currentTab) this.switchTab(tab);
        }
      });
    }
    switchTab(tabName) {
      $6b0a22f9b1f3d0ea$var$log("events", "tab:switch:triggered", {
        from: this.component.currentTab,
        to: tabName
      });
      this.applyTabState(tabName, {
        logEvent: true
      });
      this.component.page = 1;
      this.component.firstLoadedPage = 1;
      this.component.lastLoadedPage = 1;
      this.component.syncUrlState?.();
      this.component.dispatchEvent(new CustomEvent("tagalys:tab-changed", {
        detail: {
          tabName: tabName
        }
      }));
    }
    applyTabState(tabName, {logEvent: logEvent = false} = {}) {
      const previousTab = this.component.currentTab;
      this.component.currentTab = tabName;
      if (logEvent) $6b0a22f9b1f3d0ea$var$log("events", "tab:switch", {
        from: previousTab,
        to: tabName
      });
      this._updateTabButtons(tabName);
      const spellcheck = this.component.querySelector("#tagalys-search-spellcheck");
      if (spellcheck) spellcheck.hidden = tabName !== "products" || spellcheck.innerHTML.trim() === "";
      const isProducts = tabName === "products";
      const filters = this.component.querySelector("#tagalys-search-filters");
      const productGrid = this.component.querySelector("[data-search-results]");
      const plaintext = this.component.querySelector("[data-search-plaintext-results]");
      const showFilters = (0, $65zHg.shouldShowFilters)(this.component, this.component.lastProductResponse);
      filters?.classList.toggle("hidden", !showFilters);
      productGrid?.classList.toggle("hidden", !isProducts);
      plaintext?.classList.toggle("hidden", isProducts);
      $6b0a22f9b1f3d0ea$var$log("ui", "tab:switch:visibility", {
        tab: tabName,
        isProducts: isProducts,
        filtersHidden: !showFilters,
        gridHidden: !isProducts,
        plaintextHidden: isProducts
      });
    }
    updateTabVisibility() {
      const tabsContainer = this.component.querySelector("[data-search-tabs]");
      if (!tabsContainer) {
        $6b0a22f9b1f3d0ea$var$log("ui", "tabs:visibility-skipped:no-container");
        return;
      }
      if (!this.component.initStateMachine?.isFinalized) {
        tabsContainer.hidden = true;
        $6b0a22f9b1f3d0ea$var$log("ui", "tabs:visibility-pending-initialization", {
          productsResolved: this.component.initStateMachine?.productsResolved,
          availabilityResolved: this.component.initStateMachine?.availabilityResolved,
          resolved: this.component.tabAvailabilityResolved
        });
        return;
      }
      if (!this.component.tabAvailabilityResolved) {
        tabsContainer.hidden = true;
        $6b0a22f9b1f3d0ea$var$log("ui", "tabs:visibility-pending-availability", {
          resolved: this.component.tabAvailabilityResolved
        });
        return;
      }
      const buttons = Array.from(this.component.querySelectorAll("[data-tab]"));
      let hasVisibleTabs = false;
      buttons.forEach(button => {
        const tabName = button.dataset.tab;
        const isVisible = Boolean(tabName && this.component.tabAvailability[tabName]);
        button.hidden = !isVisible;
        if (isVisible) hasVisibleTabs = true;
      });
      tabsContainer.hidden = !hasVisibleTabs;
      $6b0a22f9b1f3d0ea$var$log("ui", "tabs:visibility-updated", {
        resolved: this.component.tabAvailabilityResolved,
        availability: this.component.tabAvailability,
        hasVisibleTabs: hasVisibleTabs
      });
    }
    ensureValidTab() {
      if (!this.component.initStateMachine?.isFinalized) {
        $6b0a22f9b1f3d0ea$var$log("lifecycle", "tab:ensure-valid:skipped:initializing", {
          productsResolved: this.component.initStateMachine?.productsResolved,
          availabilityResolved: this.component.initStateMachine?.availabilityResolved
        });
        return;
      }
      if (!this.component.tabAvailabilityResolved) return;
      $6b0a22f9b1f3d0ea$var$log("lifecycle", "tab:ensure-valid:start", {
        currentTab: this.component.currentTab,
        availability: this.component.tabAvailability
      });
      if (this.component.tabAvailability[this.component.currentTab]) {
        $6b0a22f9b1f3d0ea$var$log("lifecycle", "tab:ensure-valid:current-tab-available", {
          currentTab: this.component.currentTab
        });
        if (this.component.currentTab !== "products") this.component.loadCurrentTabResults();
        return;
      }
      const fallbackTab = $6b0a22f9b1f3d0ea$export$13b3d12a3f56b44e.find(tab => this.component.tabAvailability[tab]);
      if (fallbackTab) {
        $6b0a22f9b1f3d0ea$var$log("ui", "tab:fallback-selected", {
          from: this.component.currentTab,
          to: fallbackTab,
          reason: "current-tab-unavailable"
        });
        this.switchTab(fallbackTab);
        return;
      }
      $6b0a22f9b1f3d0ea$var$log("errors", "tab:ensure-valid:no-available-tabs", {
        currentTab: this.component.currentTab,
        availability: this.component.tabAvailability
      });
      this.component.loadCurrentTabResults();
    }
    renderPlaintextResults(payload = {}) {
      const container = this.component.querySelector("[data-search-plaintext-results]");
      const paginationContainer = this.component.querySelector("[data-search-pagination]");
      if (!container || !paginationContainer) return;
      const items = Array.isArray(payload.items) ? payload.items : [];
      const hasMore = Boolean(payload.hasMore);
      const query = (0, $65zHg.resolveQuery)(null, this.component.query);
      if (!items.length) {
        container.innerHTML = `\n        <div class="max-w-[472px] mx-auto text-center py-16">\n          <p class="text-scheme-links">${(0, 
        $65zHg.escapeHTML)((0, $65zHg.interpolate)((0, $65zHg.getTranslation)("search.noResults", "Missing translation"), {
          terms: query
        }))}</p>\n        </div>\n      `;
        paginationContainer.innerHTML = "";
        return;
      }
      container.innerHTML = `\n      <div class="flex flex-col items-center gap-4 max-w-[472px] mx-auto">\n        ${items.map(item => `\n            <a href="${(0, 
      $65zHg.escapeHTML)(item.url || "#")}" class="flex flex-col gap-4 items-center w-full group">\n              <span class="text-xl font-serif text-scheme-links leading-[1.1] tracking-[-0.72px] text-center group-hover:opacity-70 transition-opacity">\n                ${(0, 
      $65zHg.escapeHTML)(item.title || "")}\n              </span>\n              ${$6b0a22f9b1f3d0ea$var$renderPlaintextDivider()}\n            </a>\n          `).join("")}\n      </div>\n    `;
      paginationContainer.innerHTML = `\n      <div class="flex items-center justify-center gap-gutter tablet:w-full">\n        ${hasMore ? `<button type="button" class="btn btn--primary min-w-[350px] [--columns:3] tablet:min-w-0 tablet:w-full py-4" data-load-more-plaintext>${(0, 
      $65zHg.escapeHTML)((0, $65zHg.getTranslation)("collection.pagination.load_more", "Missing translation"))}</button>` : ""}\n      </div>\n    `;
      const loadMore = paginationContainer.querySelector("[data-load-more-plaintext]");
      if (loadMore) loadMore.addEventListener("click", () => {
        this.component.loadMorePlaintextResults?.();
      });
    }
    normalizeSuggestionsResults(response, tabName, requestedCount = 0) {
      const sectionName = this._getSuggestionsSectionForTab(tabName);
      const section = sectionName ? response?.sections?.[sectionName] : null;
      const rawItems = Array.isArray(section?.items) ? section.items : [];
      const items = rawItems.map(item => ({
        url: item?.link || item?.url || "",
        title: item?.title || item?.name || item?.text || ""
      })).filter(item => item.url && item.title);
      const targetCount = Math.max(1, Number(requestedCount) || 1);
      const hasMore = items.length > targetCount;
      const visibleItems = items.slice(0, targetCount);
      return {
        items: visibleItems,
        receivedCount: items.length,
        targetCount: targetCount,
        shown: visibleItems.length,
        hasMore: hasMore
      };
    }
    _getSuggestionsSectionForTab(tabName) {
      return $6b0a22f9b1f3d0ea$var$SECTION_BY_TAB[tabName] || null;
    }
    _updateTabButtons(activeTab) {
      this.component.querySelectorAll("[data-tab]").forEach(button => {
        const isActive = button.dataset.tab === activeTab;
        $6b0a22f9b1f3d0ea$var$ACTIVE_BUTTON_CLASSES.forEach(className => button.classList.toggle(className, isActive));
        if (isActive) button.setAttribute("data-active", ""); else button.removeAttribute("data-active");
        button.setAttribute("aria-selected", isActive ? "true" : "false");
      });
      const activeButton = this.component.querySelector(`[data-tab="${activeTab}"]`);
      const activeButtonId = activeButton?.id;
      if (activeButtonId) {
        const productsPanel = this.component.querySelector('[data-search-results][role="tabpanel"]');
        const plaintextPanel = this.component.querySelector('[data-search-plaintext-results][role="tabpanel"]');
        const activePanel = activeTab === "products" ? productsPanel : plaintextPanel;
        if (activePanel) activePanel.setAttribute("aria-labelledby", activeButtonId);
      }
    }
  }
  var $65zHg = parcelRequire("65zHg");
  var $cJzMp = parcelRequire("cJzMp");
  const $d49b2c5365c47c22$var$log = (0, $cJzMp.createLogger)("sort-manager");
  class $d49b2c5365c47c22$export$d071ab957fcf2c6d {
    constructor(component) {
      this.component = component;
      this._boundHandleSortChange = this._handleSortChange.bind(this);
    }
    renderSortControl(response) {
      const selectedOption = response.sort_options?.find(option => option.selected) || response.sort_options?.[0];
      const selectedValue = selectedOption?.id || "";
      const selectedLabel = selectedOption?.label || "";
      return `\n      <custom-select\n        class="relative flex transition-all data-is-open:z-[10000] has-closing-animation"\n        data-id="${this.component.sectionId}-product-sort"\n        data-scroll-lock="tablet"\n      >\n        <label\n          class="cursor-pointer flex no-js:hidden group"\n          data-role="button"\n          data-select-trigger\n          tabindex="0"\n        >\n          <div class="flex items-center gap-2">\n            <div class="text-heading-2xs tablet:text-sm text-inherit transition-colors supports-hover:hover:opacity-80 flex gap-1 items-center text-scheme-links">\n              <div>${(0, 
      $65zHg.escapeHTML)(this.component.sortTitle)}:</div>\n              <div\n                class="\n                  font-normal tablet:btn-text mb-0\n                "\n                data-facet="sort-by-${this.component.sectionId}"\n              >\n                ${(0, 
      $65zHg.escapeHTML)(selectedLabel)}\n              </div>\n            </div>\n            <svg\n              class="h-1.75 w-auto text-inherit transition-all hidden desktop:block group-aria-expanded:rotate-180"\n              role="presentation"\n              width="10"\n              height="6"\n              viewBox="0 0 10 6"\n              fill="none"\n              xmlns="http://www.w3.org/2000/svg"\n            >\n              <path fill="currentColor" d="m.707 0 4.95 4.95-.707.707L0 .707z"></path>\n              <path fill="currentColor" d="m9.9.707-4.95 4.95-.707-.707L9.193 0z"></path>\n            </svg>\n          </div>\n          <select\n            name="sort_by"\n            class="sr-only"\n            data-native-select\n            data-sort-selector\n            tabindex="-1"\n            aria-hidden="true"\n          >\n            ${(response.sort_options || []).map(option => `<option value="${(0, 
      $65zHg.escapeHTML)(option.id)}" ${option.id === selectedValue ? "selected" : ""}>${(0, 
      $65zHg.escapeHTML)(option.label)}</option>`).join("")}\n          </select>\n        </label>\n        <div\n          class="drawer-underlay fixed inset-0 bg-mulch-30 backdrop-blur-[2px] opacity-0 pointer-events-none transition-opacity z-90 hidden tablet:block"\n          data-underlay\n        ></div>\n        <div\n          class="\n            filter-dropdown hidden absolute top-full right-0 bg-scheme-background border border-t-mulch border-scheme-border min-w-79 overflow-y-auto mt-4 desktop:pt-5 pb-8 flex flex-col gap-3 items-start z-10\n            tablet:fixed tablet:inset-x-0 tablet:bottom-0 tablet:top-auto tablet:z-100 tablet:w-full tablet:max-h-[80vh] tablet:mt-0 tablet:border-t tablet:border-scheme-border tablet:shadow-2xl tablet:pb-8 is-mobile-sort\n          "\n          data-dropdown\n        >\n          <div class="hidden tablet:flex justify-between items-end pb-3 px-offset min-h-[56px] relative w-full mb-2">\n            <div class="text-scheme-links font-normal font-sans">\n              <span class="text-sm">${(0, 
      $65zHg.escapeHTML)(this.component.sortTitle)}</span>\n            </div>\n            <button\n              type="button"\n              class="text-sm text-scheme-links cursor-pointer font-normal font-sans"\n              data-close\n            >\n              ${(0, 
      $65zHg.escapeHTML)(this.component.closeLabel)}\n            </button>\n            <div class="absolute bottom-0 left-offset right-offset h-px bg-scheme-border"></div>\n          </div>\n          <div class="flex flex-col gap-3.5 items-start w-full px-3 tablet:px-offset">\n            ${(response.sort_options || []).map(option => `\n              <div\n                class="group/sort flex gap-2.5 items-center cursor-pointer w-full py-1.75 -my-1.75 flex-row-reverse justify-end"\n                data-option\n                data-value="${(0, 
      $65zHg.escapeHTML)(option.id)}"\n                ${option.id === selectedValue ? 'data-selected="true"' : ""}\n              >\n                <span class="text-md font-serif text-scheme-links whitespace-nowrap">\n                  ${(0, 
      $65zHg.escapeHTML)(option.label)}\n                </span>\n                <span\n                  data-indicator\n                  class="\n                    relative transition-all shrink-0 inline-block size-2.5 m-0.5\n                    outline outline-1 outline-offset-2 outline-scheme-links\n                    rounded-full\n                    group-hover/sort:bg-scheme-links\n                    ${option.id === selectedValue ? "bg-scheme-links" : ""}\n                  "\n                ></span>\n              </div>\n            `).join("")}\n          </div>\n        </div>\n      </custom-select>\n    `;
    }
    bindSortListener() {
      const sortSelect = this.component.querySelector("[data-sort-selector]");
      if (!sortSelect) return;
      sortSelect.addEventListener("change", this._boundHandleSortChange);
    }
    _handleSortChange(event) {
      const sortBy = event.target.value;
      if (!sortBy) return;
      $d49b2c5365c47c22$var$log("events", "sort:changed", {
        sortBy: sortBy
      });
      this.component.dispatchEvent(new CustomEvent("tagalys:sort-changed", {
        detail: {
          sortBy: sortBy
        }
      }));
    }
  }
  var $cJzMp = parcelRequire("cJzMp");
  const $58babd088c980986$var$log = (0, $cJzMp.createLogger)("suggestions-manager");
  class $58babd088c980986$export$b847c80c0c772b96 {
    constructor(component, client) {
      this.component = component;
      this.client = client;
      this._nonProductRequestId = 0;
      this._pendingSuggestionsRequestId = 0;
      this._pendingSuggestionsMode = null;
      this._pendingSuggestionsTab = null;
      this._pendingSuggestionsQuery = null;
      this._pendingSuggestionsCount = 0;
    }
    fetchTabAvailability(paginationManager, tabManager) {
      this._pendingSuggestionsMode = "availability";
      const initialStep = 1;
      this._pendingSuggestionsCount = paginationManager.getNonProductVisibleCountForStep(initialStep);
      const availabilityRequestCount = paginationManager.getNonProductRequestCountForStep(initialStep);
      const params = this.client._buildSuggestionsParams(this.component.query, 1, this.component.nonProductPerPage, availabilityRequestCount);
      $58babd088c980986$var$log("network", "SearchSuggestions:availability:dispatch", {
        params: JSON.stringify(params),
        query: this.component.query,
        step: initialStep,
        visibleCount: this._pendingSuggestionsCount,
        requestCount: availabilityRequestCount
      });
      const dispatched = this._dispatchSuggestionsRequest(params, "availability");
      if (!dispatched) {
        this.component.initStateMachine.resolveAvailability({
          products: true,
          articles: false,
          categories: false,
          pages: false
        }, false);
        tabManager.updateTabVisibility();
      }
    }
    performSuggestionsSearch(paginationManager) {
      $58babd088c980986$var$log("events", "SearchSuggestions:performSuggestionsSearch:invoked", {
        tab: this.component.currentTab,
        step: paginationManager.getNonProductStep(this.component.currentTab),
        source: "performSuggestionsSearch"
      });
      this.performSuggestionsSearchWithOptions(paginationManager);
    }
    performSuggestionsSearchWithOptions(paginationManager, {tab: tab = this.component.currentTab, step: step = paginationManager.getNonProductStep(this.component.currentTab), sectionCounts: sectionCounts = null, source: source = "unspecified"} = {}) {
      if (!window.Tagalys?.APIConnector?.SearchSuggestions?.new) {
        $58babd088c980986$var$log("errors", "SearchSuggestions:dispatch-skipped:no-api");
        return;
      }
      this._pendingSuggestionsRequestId = ++this._nonProductRequestId;
      this._pendingSuggestionsMode = "results";
      this._pendingSuggestionsTab = tab;
      this._pendingSuggestionsQuery = this.component.query;
      const safeStep = Math.max(1, Number(step) || 1);
      const previousStep = paginationManager.getNonProductStep(tab);
      this._pendingSuggestionsCount = paginationManager.getNonProductVisibleCountForStep(safeStep);
      const requestCount = paginationManager.getNonProductRequestCountForStep(safeStep);
      const params = this.client._buildSuggestionsParams(this.component.query, 1, this.component.nonProductPerPage, requestCount, {
        sectionCounts: sectionCounts
      });
      $58babd088c980986$var$log("network", "SearchSuggestions:dispatch:constructing", {
        params: JSON.stringify(params),
        nonProductPerPage: this.component.nonProductPerPage,
        query: this.component.query,
        tab: tab,
        source: source,
        previousStep: previousStep,
        step: safeStep,
        visibleCount: this._pendingSuggestionsCount,
        requestCount: requestCount,
        sectionCounts: sectionCounts
      });
      this._dispatchSuggestionsRequest(params, "results");
    }
    loadMorePlaintextResults(paginationManager, tabManager) {
      if (this.component.currentTab === "products") return;
      const previousStep = paginationManager.getNonProductStep(this.component.currentTab);
      const nextStep = previousStep + 1;
      paginationManager.setNonProductStep(this.component.currentTab, nextStep);
      const visibleCount = paginationManager.getNonProductVisibleCountForStep(nextStep);
      const requestCount = paginationManager.getNonProductRequestCountForStep(nextStep);
      const sectionCounts = this.getNonProductSectionCountsForRequest(tabManager, paginationManager, this.component.currentTab, nextStep);
      $58babd088c980986$var$log("events", "plaintext:load-more", {
        tab: this.component.currentTab,
        previousStep: previousStep,
        nextStep: nextStep,
        visibleCount: visibleCount,
        requestCount: requestCount,
        sectionCounts: sectionCounts
      });
      this.performSuggestionsSearchWithOptions(paginationManager, {
        tab: this.component.currentTab,
        step: nextStep,
        sectionCounts: sectionCounts,
        source: "loadMorePlaintextResults"
      });
    }
    getNonProductSectionCountsForRequest(tabManager, paginationManager, tabName, step) {
      const requestCount = paginationManager.getNonProductRequestCountForStep(step);
      const activeSection = tabManager._getSuggestionsSectionForTab(tabName);
      const counts = {
        products: 0,
        articles: 0,
        pages: 0,
        collections: 0
      };
      if (activeSection && Object.prototype.hasOwnProperty.call(counts, activeSection)) counts[activeSection] = requestCount;
      $58babd088c980986$var$log("network", "SearchSuggestions:section-counts:computed", {
        tab: tabName,
        step: step,
        activeSection: activeSection,
        requestCount: requestCount,
        counts: counts
      });
      return counts;
    }
    _dispatchSuggestionsRequest(params, mode) {
      this._pendingSuggestionsMode = mode;
      $58babd088c980986$var$log("network", "SearchSuggestions:instance:recreate", {
        mode: mode,
        params: JSON.stringify(params)
      });
      const instance = this.client._createSuggestionsInstance(params, response => this._handleSuccess(response), response => this._handleFailure(response));
      if (!instance) {
        $58babd088c980986$var$log("errors", "SearchSuggestions:dispatch-skipped:create-failed", {
          mode: mode
        });
        return false;
      }
      $58babd088c980986$var$log("network", "SearchSuggestions:dispatch:dispatched", {
        mode: mode,
        requestId: this._pendingSuggestionsRequestId,
        tab: this._pendingSuggestionsTab,
        finalParams: JSON.stringify(instance.params)
      });
      try {
        instance.helpers.call();
        return true;
      } catch (error) {
        $58babd088c980986$var$log("errors", "SearchSuggestions:dispatch:call-exception", {
          mode: mode,
          error: (0, $cJzMp.serializeError)(error)
        });
        return false;
      }
    }
    _handleSuccess(response) {
      if (this._pendingSuggestionsMode === "availability") this._handleAvailabilitySuccess(response); else this._handleResultsSuccess(response);
    }
    _handleFailure(response) {
      if (this._pendingSuggestionsMode === "availability") this._handleAvailabilityFailure(response); else this._handleResultsFailure(response);
    }
    _handleAvailabilitySuccess(response) {
      $58babd088c980986$var$log("network", "SearchSuggestions:handleAvailabilitySuccess:start", {
        response: JSON.stringify(response)
      });
      const sections = response?.sections || {};
      this.component.initialPlaintextResults = sections;
      const hasProductsTotal = Number.isFinite(Number(sections.products?.total_count));
      const productsTotal = hasProductsTotal ? Number(sections.products?.total_count) : null;
      const articlesCount = Array.isArray(sections.articles?.items) ? sections.articles.items.length : 0;
      const collectionsCount = Array.isArray(sections.collections?.items) ? sections.collections.items.length : 0;
      const pagesCount = Array.isArray(sections.pages?.items) ? sections.pages.items.length : 0;
      const availability = {
        products: hasProductsTotal ? productsTotal > 0 : true,
        articles: articlesCount > 0,
        categories: collectionsCount > 0,
        pages: pagesCount > 0
      };
      $58babd088c980986$var$log("network", "SearchSuggestions:availability:onSuccess", {
        query: this.component.query,
        availability: availability,
        productsTotal: productsTotal,
        hasProductsTotal: hasProductsTotal,
        undefinedSections: response?.undefined_sections || []
      });
      this.component.initStateMachine.resolveAvailability(availability, true);
      this.component.tabManager?.updateTabVisibility();
    }
    _handleAvailabilityFailure(response) {
      $58babd088c980986$var$log("errors", "SearchSuggestions:handleAvailabilityFailure", {
        response: response
      });
      console.warn("Tagalys tab availability request failed:", response);
      this.component.initStateMachine.resolveAvailability({
        products: true,
        articles: false,
        categories: false,
        pages: false
      }, false);
      this.component.tabManager?.updateTabVisibility();
    }
    _handleResultsSuccess(response) {
      const context = {
        requestId: this._pendingSuggestionsRequestId,
        activeRequestId: this._nonProductRequestId,
        pendingTab: this._pendingSuggestionsTab,
        currentTab: this.component.currentTab,
        pendingQuery: this._pendingSuggestionsQuery,
        currentQuery: this.component.query,
        page: this.component.page
      };
      if (this._pendingSuggestionsRequestId !== this._nonProductRequestId) {
        $58babd088c980986$var$log("network", "SearchSuggestions:onSuccess:skipped", {
          ...(0, $cJzMp.withDebugReason)("stale-request-id", context)
        });
        return;
      }
      if (this._pendingSuggestionsTab !== this.component.currentTab) {
        $58babd088c980986$var$log("network", "SearchSuggestions:onSuccess:skipped", {
          ...(0, $cJzMp.withDebugReason)("tab-changed", context)
        });
        return;
      }
      if (this._pendingSuggestionsQuery !== this.component.query) {
        $58babd088c980986$var$log("network", "SearchSuggestions:onSuccess:skipped", {
          ...(0, $cJzMp.withDebugReason)("query-changed", context)
        });
        return;
      }
      const paginationManager = this.component.paginationManager;
      const tabManager = this.component.tabManager;
      $58babd088c980986$var$log("network", "SearchSuggestions:onSuccess", {
        currentTab: this.component.currentTab,
        pendingTab: this._pendingSuggestionsTab,
        page: this.component.page,
        requestedCount: this._pendingSuggestionsCount,
        pendingStep: paginationManager?.getNonProductStep(this.component.currentTab)
      });
      const sectionName = tabManager?._getSuggestionsSectionForTab(this._pendingSuggestionsTab);
      $58babd088c980986$var$log("network", "SearchSuggestions:section:resolved", {
        tab: this._pendingSuggestionsTab,
        section: sectionName
      });
      if (!sectionName) {
        $58babd088c980986$var$log("errors", "SearchSuggestions:onSuccess:skipped", {
          ...(0, $cJzMp.withDebugReason)("missing-section-for-tab", context)
        });
        return;
      }
      const payload = tabManager.normalizeSuggestionsResults(response, this.component.currentTab, this._pendingSuggestionsCount);
      const rawItems = response?.sections?.[sectionName]?.items;
      const rawCount = Array.isArray(rawItems) ? rawItems.length : 0;
      $58babd088c980986$var$log("network", "SearchSuggestions:normalized", {
        tab: this.component.currentTab,
        section: sectionName,
        rawCount: rawCount,
        filteredCount: payload.items.length,
        receivedCount: payload.receivedCount,
        targetCount: payload.targetCount,
        shown: payload.shown,
        hasMore: payload.hasMore,
        undefinedSections: response?.undefined_sections || []
      });
      const stepBeforeSync = paginationManager?.getNonProductStep(this.component.currentTab);
      paginationManager?.setNonProductStepForVisibleCount(this.component.currentTab, payload.targetCount);
      const stepAfterSync = paginationManager?.getNonProductStep(this.component.currentTab);
      $58babd088c980986$var$log("network", "SearchSuggestions:step-sync", {
        tab: this.component.currentTab,
        stepBeforeSync: stepBeforeSync,
        stepAfterSync: stepAfterSync,
        payloadTargetCount: payload.targetCount,
        payloadShown: payload.shown
      });
      tabManager?.renderPlaintextResults(payload);
      const headingCount = this.component.querySelector("#tagalys-search-count-inline");
      if (headingCount) headingCount.textContent = "";
      this.component.syncUrlState?.();
    }
    _handleResultsFailure(response) {
      if (this._pendingSuggestionsRequestId !== this._nonProductRequestId) return;
      $58babd088c980986$var$log("errors", "SearchSuggestions:onFailure", {
        currentTab: this.component.currentTab,
        response: response
      });
      console.warn(`Tagalys search suggestions failed for ${this.component.currentTab}:`, response);
    }
  }
  var $ezkA5 = parcelRequire("ezkA5");
  var $65zHg = parcelRequire("65zHg");
  var $cJzMp = parcelRequire("cJzMp");
  const $0e05cbfe21788653$var$log = (0, $cJzMp.createLogger)("renderer");
  class $0e05cbfe21788653$export$88530751e3977073 {
    constructor(component, filterManager, paginationManager) {
      this.component = component;
      this.filterManager = filterManager;
      this.paginationManager = paginationManager;
    }
    renderSearchResults(response, helpers) {
      const resultsContainer = this.component.querySelector("[data-search-results]");
      const paginationContainer = this.component.querySelector("[data-search-pagination]");
      const spellcheckContainer = this.component.querySelector("#tagalys-search-spellcheck");
      if (!resultsContainer) return;
      if (spellcheckContainer) this._renderSpellcheck(spellcheckContainer, helpers, response);
      if (response.total_count !== undefined) this.renderSearchCount(response.total_count, helpers);
      const {mode: mode = "replace", page: resolvedPage = response.page || this.component.page || 1} = this.component.paginationAction || {};
      if (response.products && response.products.length > 0) {
        let html = "";
        response.products.forEach(product => {
          html += (0, $ezkA5.createProductCardHTML)(product, {
            toggleQuickAdd: true,
            toggleBadges: true,
            toggleDiscountBadge: true,
            badgeLimit: 3,
            mobileBadgeLimit: 1
          }) || "";
        });
        if (mode === "append") resultsContainer.insertAdjacentHTML("beforeend", html); else if (mode === "prepend") resultsContainer.insertAdjacentHTML("afterbegin", html); else resultsContainer.innerHTML = html;
      } else {
        resultsContainer.innerHTML = "";
        this.renderStatusMessage({
          message: (0, $65zHg.interpolate)((0, $65zHg.getTranslation)("search.noResults", "Missing translation"), {
            terms: (0, $65zHg.resolveQuery)(helpers, this.component.query)
          }),
          buttonLabel: (0, $65zHg.getTranslation)("search.open_search", "Missing translation")
        });
      }
      if (this.filterManager) this.filterManager.render(response, response.total_count);
      if (mode === "append") this.component.lastLoadedPage = resolvedPage; else if (mode === "prepend") this.component.firstLoadedPage = resolvedPage; else {
        this.component.firstLoadedPage = resolvedPage;
        this.component.lastLoadedPage = resolvedPage;
      }
      this.component.page = resolvedPage;
      this.component.paginationAction = null;
      if (this.paginationManager) {
        const totalPages = Math.ceil(response.total_count / this.component.perPage);
        this.paginationManager.renderLoadPrevious(totalPages);
        if (paginationContainer) this.paginationManager.renderPagination(response.total_count, paginationContainer);
      }
      this.component.syncUrlState?.();
      this.component.handleProductResultsRendered?.();
      this.component.dispatchEvent(new CustomEvent("tagalys:search-results-loaded", {
        detail: {
          query: this.component.query,
          total_count: response.total_count,
          products: response.products
        }
      }));
    }
    renderSearchCount(count, helpers) {
      const resolvedQuery = (0, $65zHg.resolveQuery)(helpers, this.component.query);
      const breadcrumbCurrentContainer = this.component.querySelector("#tagalys-search-breadcrumb-current");
      const headingTextContainer = this.component.querySelector("#tagalys-search-heading-text");
      const headingCountContainer = this.component.querySelector("#tagalys-search-count-inline");
      const localizedBreadcrumb = (0, $65zHg.interpolate)((0, $65zHg.getTranslation)("search.resultsBreadcrumb", "Missing translation"), {
        terms: resolvedQuery
      });
      const localizedHeading = (0, $65zHg.interpolate)((0, $65zHg.getTranslation)("search.resultsHeading", "Missing translation"), {
        terms: resolvedQuery
      });
      if (breadcrumbCurrentContainer) breadcrumbCurrentContainer.textContent = localizedBreadcrumb;
      if (headingTextContainer) headingTextContainer.textContent = localizedHeading;
      if (headingCountContainer) headingCountContainer.textContent = `${count}`;
      const countContainer = document.querySelector("#tagalys-search-count");
      if (countContainer) countContainer.textContent = localizedHeading;
      document.querySelectorAll("[data-product-count]").forEach(el => {
        el.textContent = `${count}`;
      });
    }
    renderEmptyQueryState() {
      const filtersContainer = this.component.querySelector("#tagalys-search-filters");
      filtersContainer?.classList.add("hidden");
      const paginationContainer = this.component.querySelector("[data-search-pagination]");
      paginationContainer?.classList.add("hidden");
      const headingText = this.component.querySelector("#tagalys-search-heading-text");
      if (headingText) headingText.textContent = (0, $65zHg.getTranslation)("search.title", "Missing translation");
      const headingCount = this.component.querySelector("#tagalys-search-count-inline");
      if (headingCount) headingCount.textContent = "";
      const breadcrumb = this.component.querySelector("#tagalys-search-breadcrumb-current");
      if (breadcrumb) breadcrumb.textContent = (0, $65zHg.getTranslation)("search.title", "Missing translation");
      this.renderStatusMessage({
        message: (0, $65zHg.getTranslation)("search.empty_query", "Missing translation"),
        buttonLabel: (0, $65zHg.getTranslation)("search.open_search", "Missing translation")
      });
    }
    renderStatusMessage({message: message, buttonLabel: buttonLabel, onButtonClick: onButtonClick}) {
      const container = this.component.querySelector("#tagalys-search-spellcheck");
      if (!container) return;
      container.innerHTML = `\n      <div class="flex flex-col items-center gap-6 text-center">\n        <p class="text-scheme-links">\n          ${(0, 
      $65zHg.escapeHTML)(message)}\n        </p>\n        ${buttonLabel ? `<button type="button" class="btn btn--primary" data-open-header-search>${(0, 
      $65zHg.escapeHTML)(buttonLabel)}</button>` : ""}\n      </div>\n    `;
      container.hidden = false;
      const openButton = container.querySelector("[data-open-header-search]");
      if (openButton) openButton.addEventListener("click", onButtonClick || this._openSearchFallback);
    }
    _renderSpellcheck(spellcheckContainer, helpers, response) {
      const isCorrected = helpers.isSpellingCorrectedQuery();
      const correctedQuery = helpers.getQuery?.();
      const originalQuery = helpers.getOriginalQuery?.();
      if (isCorrected) {
        const message = (0, $65zHg.interpolate)((0, $65zHg.getTranslation)("search.spellingCorrectedResults", "Missing translation"), {
          original_terms: originalQuery || this.component.query,
          terms: correctedQuery || (0, $65zHg.resolveQuery)(helpers, this.component.query)
        });
        spellcheckContainer.innerHTML = message;
        spellcheckContainer.hidden = false;
      } else {
        spellcheckContainer.hidden = true;
        spellcheckContainer.innerHTML = "";
      }
    }
    _openSearchFallback() {
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      let predictiveSearch;
      if (isMobile) predictiveSearch = document.querySelector("#header-mobile-predictive-search"); else predictiveSearch = document.querySelector("#header-desktop-predictive-search");
      if (predictiveSearch) {
        const details = predictiveSearch.querySelector("[data-predictive-search-details]");
        if (details instanceof HTMLDetailsElement) {
          const summary = details.querySelector("summary");
          if (summary instanceof HTMLElement) summary.click();
          return;
        }
        const toggle = predictiveSearch.querySelector("[data-predictive-search-toggle]");
        if (toggle instanceof HTMLElement) {
          toggle.click();
          return;
        }
      }
      const toggle = document.querySelector("[data-predictive-search-toggle]") || document.querySelector("[data-mobile-search-toggle]");
      if (toggle instanceof HTMLElement) toggle.click(); else {
        const details = document.querySelector("[data-predictive-search-details]");
        if (details instanceof HTMLDetailsElement) {
          details.open = true;
          const input = details.querySelector("[data-search-input]");
          if (input instanceof HTMLElement) input.focus();
        }
      }
    }
  }
  class $f1f901e5be9fef2e$export$a05b731483994c07 {
    constructor(log) {
      this.log = log;
      this._isFinalized = false;
      this.productsResolved = false;
      this.productsSucceeded = false;
      this.availabilityResolved = false;
      this.availabilitySucceeded = false;
      this.initialProductResponse = null;
      this.initialProductHelpers = null;
      this.tabAvailability = {
        products: false,
        articles: false,
        categories: false,
        pages: false
      };
      this.finalizeCallback = null;
    }
    resolveProducts(response, helpers, succeeded, totalCount) {
      if (this._isFinalized) return;
      this.productsResolved = true;
      this.productsSucceeded = succeeded;
      this.initialProductResponse = response;
      this.initialProductHelpers = helpers;
      this.tabAvailability.products = totalCount > 0;
      this.log("lifecycle", "init-state-machine:resolve-products", {
        succeeded: succeeded,
        totalCount: totalCount,
        tabAvailabilityProducts: this.tabAvailability.products
      });
      this.checkCompletion();
    }
    resolveAvailability(availability, succeeded) {
      if (this._isFinalized) return;
      this.availabilityResolved = true;
      this.availabilitySucceeded = succeeded;
      Object.keys(availability).forEach(key => {
        if (key !== "products") this.tabAvailability[key] = availability[key]; else if (!this.productsResolved) this.tabAvailability.products = availability.products;
      });
      this.log("lifecycle", "init-state-machine:resolve-availability", {
        succeeded: succeeded,
        availability: availability
      });
      this.checkCompletion();
    }
    onFinalize(callback) {
      this.finalizeCallback = callback;
      this.checkCompletion();
    }
    checkCompletion() {
      if (this._isFinalized) return;
      if (this.productsResolved && this.availabilityResolved) {
        this._isFinalized = true;
        this.log("lifecycle", "init-state-machine:finalized", {
          availability: this.tabAvailability,
          productsSucceeded: this.productsSucceeded,
          availabilitySucceeded: this.availabilitySucceeded
        });
        if (this.finalizeCallback) this.finalizeCallback(this.selectedTab);
      }
    }
    get isFinalized() {
      return this._isFinalized;
    }
    get isWaiting() {
      return !this._isFinalized && (this.productsResolved || this.availabilityResolved);
    }
    get selectedTab() {
      const orderedTabs = [ "products", "articles", "categories", "pages" ];
      const visibleTabs = orderedTabs.filter(tab => this.tabAvailability[tab]);
      return visibleTabs[0] || "products";
    }
    get storedResponse() {
      return {
        response: this.initialProductResponse,
        helpers: this.initialProductHelpers
      };
    }
  }
  var $65zHg = parcelRequire("65zHg");
  const $56ecffb5022cfd62$var$PRODUCT_SKELETON_COUNT = 10;
  const $56ecffb5022cfd62$var$PLAINTEXT_SKELETON_COUNT = 3;
  const $56ecffb5022cfd62$var$SKELETON_ATTR = "data-skeleton";
  class $56ecffb5022cfd62$export$27a22c945b52f415 {
    constructor(component) {
      this.component = component;
    }
    showProducts() {
      const container = this.component.querySelector("[data-search-results]");
      if (!container) return;
      container.classList.remove("hidden");
      const html = Array.from({
        length: $56ecffb5022cfd62$var$PRODUCT_SKELETON_COUNT
      }, () => this._createProductSkeleton()).join("");
      container.innerHTML = html;
    }
    showPlaintext() {
      const container = this.component.querySelector("[data-search-plaintext-results]");
      if (!container) return;
      container.classList.remove("hidden");
      const html = Array.from({
        length: $56ecffb5022cfd62$var$PLAINTEXT_SKELETON_COUNT
      }, () => this._createPlaintextSkeleton()).join("");
      container.innerHTML = `\n      <div class="flex flex-col items-center gap-4 max-w-[472px] mx-auto">\n        ${html}\n      </div>\n    `;
    }
    clearProducts() {
      this._clearContainer("[data-search-results]");
    }
    clearPlaintext() {
      this._clearContainer("[data-search-plaintext-results]");
    }
    clearAll() {
      this.clearProducts();
      this.clearPlaintext();
    }
    _clearContainer(selector) {
      const container = this.component.querySelector(selector);
      if (!container) return;
      container.querySelectorAll(`[${$56ecffb5022cfd62$var$SKELETON_ATTR}]`).forEach(el => el.remove());
      if (!container.hasChildNodes()) container.innerHTML = "";
    }
    _createProductSkeleton() {
      return `\n      <div class="product-card group relative" ${$56ecffb5022cfd62$var$SKELETON_ATTR}>\n        <div class="product-card__media relative z-0 animate-pulse">\n          <div class="relative block z-1 aspect-9/10 bg-black-10"></div>\n        </div>\n        <div class="product-card__content animate-pulse">\n          <div class="product-card__meta flex flex-col pt-4">\n            <div class="h-4 w-3/4 bg-black-10 rounded"></div>\n          </div>\n        </div>\n      </div>\n    `;
    }
    _createPlaintextSkeleton() {
      return `\n      <div class="w-full animate-pulse" ${$56ecffb5022cfd62$var$SKELETON_ATTR}>\n        <div class="h-5 w-64 bg-black-10 rounded mx-auto"></div>\n        <div class="h-px w-full bg-black-10 mt-4"></div>\n      </div>\n    `;
    }
  }
  var $cJzMp = parcelRequire("cJzMp");
  const $63afb175e9080251$var$log = (0, $cJzMp.createLogger)("tagalys-search-results");
  class $63afb175e9080251$var$TagalysSearchResults extends HTMLElement {
    constructor() {
      super();
      this.log = $63afb175e9080251$var$log;
      this.query = this.dataset.query || "";
      this.perPage = parseInt(this.dataset.perPage) || 24;
      this.nonProductPerPage = parseInt(this.dataset.nonProductPerPage || this.dataset.perPage) || 24;
      this.sectionId = this.dataset.sectionId || "tagalys";
      this.formId = `FilterForm-${this.sectionId}`;
      this.columnsThreeLabel = this.dataset.columnsThreeLabel || "";
      this.columnsFiveLabel = this.dataset.columnsFiveLabel || "";
      this.sortTitle = this.dataset.sortTitle || "";
      this.closeLabel = this.dataset.closeLabel || "";
      this.currentTab = "products";
      const {page: page, sort: sort, filters: filters} = (0, $92546df26b4e6577$export$b011c1f6ae44b5bf).hydrateParams();
      this.page = page || parseInt(this.dataset.page) || 1;
      this.sortBy = sort || this.dataset.sortBy || "trending";
      this.firstLoadedPage = this.page;
      this.lastLoadedPage = this.page;
      this.filters = filters || {};
      this.nonProductStepByTab = {};
      this.initialFilters = null;
      this.lastProductResponse = null;
      this.initialPlaintextResults = null;
      this.paginationAction = null;
      this.isInitialized = false;
      this.client = new (0, $0e64f75d8b506542$export$fd6fefded6aba03);
      this.filterManager = new (0, $4f98279e176cab87$export$4c85e4ca0d95642f)(this, "#tagalys-search-filters");
      this.paginationManager = new (0, $dd709126808195a9$export$765f97f01dfc5b0)(this);
      this.tabManager = new (0, $6b0a22f9b1f3d0ea$export$59220c853884db6b)(this);
      this.sortManager = new (0, $d49b2c5365c47c22$export$d071ab957fcf2c6d)(this);
      this.suggestionsManager = new (0, $58babd088c980986$export$b847c80c0c772b96)(this, this.client);
      this.skeletonLoader = new (0, $56ecffb5022cfd62$export$27a22c945b52f415)(this);
      this.renderer = new (0, $0e05cbfe21788653$export$88530751e3977073)(this, this.filterManager, this.paginationManager);
      this.initStateMachine = new (0, $f1f901e5be9fef2e$export$a05b731483994c07)((type, event, detail) => this.log(type, event, detail));
      this.filterManager.hydrate(this.filters);
      this.filterManager.setSortControlRenderer((component, response) => this.sortManager.renderSortControl(response));
      this.initStateMachine.onFinalize(selectedTab => {
        this.currentTab = selectedTab;
        this.log("lifecycle", "initialization:finalize", {
          selectedTab: selectedTab,
          productsTotal: this.tabAvailability.products ? "available" : "0/none",
          tabAvailability: this.tabAvailability,
          reason: "first-visible-tab"
        });
        const stored = this.initStateMachine.storedResponse;
        this.log("network", "initialization:redirect-check", {
          hasStoredResponse: Boolean(stored.response),
          hasStoredHelpers: Boolean(stored.helpers),
          hasRedirectUrl: Boolean(stored.response?.redirect_url)
        });
        if (stored.response && (0, $65zHg.handleRedirect)(stored.helpers, stored.response)) return;
        this.tabManager.updateTabVisibility();
        this.tabManager.applyTabState(selectedTab);
        this.syncUrlState();
        if (selectedTab === "products") this._renderStoredInitialProductResults(); else this.loadCurrentTabResults();
      });
      this.addEventListener("tagalys:filters-updated", this._handleFilterUpdate.bind(this));
      this.addEventListener("tagalys:page-change", this._handlePageChange.bind(this));
      this.addEventListener("tagalys:tab-changed", this._handleTabChange.bind(this));
      this.addEventListener("tagalys:sort-changed", this._handleSortChange.bind(this));
      (0, $ezkA5.onTagalysReady)(() => this._initialize());
      this.log("lifecycle", "constructed", {
        query: this.query,
        page: this.page,
        perPage: this.perPage,
        nonProductPerPage: this.nonProductPerPage,
        currentTab: this.currentTab,
        sortBy: this.sortBy,
        filters: this.filters
      });
    }
    get tabAvailability() {
      return this.initStateMachine.tabAvailability;
    }
    get tabAvailabilityResolved() {
      return this.initStateMachine.availabilityResolved;
    }
    get initialSelectionFinalized() {
      return this.initStateMachine.isFinalized;
    }
    _initialize() {
      if (this.isInitialized) return;
      this.log("lifecycle", "initializeTagalys:start", {
        query: this.query
      });
      if (!this.query) {
        this.log("lifecycle", "initializeTagalys:empty-query");
        this.renderer.renderEmptyQueryState();
        return;
      }
      this.tabManager.initTabs();
      this._setInitialPendingVisibility(true);
      this.skeletonLoader.showProducts();
      this.tabManager.updateTabVisibility();
      try {
        this.isInitialized = true;
        this.log("lifecycle", "connectors:initialized", {
          hasSearchResults: Boolean(window.Tagalys?.APIConnector?.SearchResults),
          hasSuggestions: Boolean(window.Tagalys?.APIConnector?.SearchSuggestions)
        });
        this._dispatchInitialProductSearch();
        this.suggestionsManager.fetchTabAvailability(this.paginationManager, this.tabManager);
      } catch (error) {
        this.log("errors", "initializeTagalys:exception", (0, $cJzMp.serializeError)(error));
        console.warn("Failed to initialize Tagalys search results v2:", error);
      }
    }
    _handleFilterUpdate(e) {
      this.filters = e.detail.filters;
      this.component = this;
      this.firstLoadedPage = 1;
      this.lastLoadedPage = 1;
      this._pendingScrollToResults = true;
      this._dispatchProductPageLoad(1, "replace");
    }
    _handlePageChange(e) {
      const {requestedPage: requestedPage, direction: direction} = e.detail;
      const mode = direction === "previous" ? "prepend" : "append";
      const paginationDirection = direction;
      this.log("events", `pagination:${direction}`, {
        fromPage: this.page,
        toPage: requestedPage
      });
      this.paginationManager.setLoadingState(paginationDirection, true);
      this.page = requestedPage;
      this.paginationAction = {
        mode: mode,
        page: requestedPage
      };
      this._performSearch();
    }
    _handleTabChange(e) {
      const {tabName: tabName} = e.detail;
      this.log("events", "tab:changed:controller", {
        tabName: tabName
      });
      this.loadCurrentTabResults();
    }
    _handleSortChange(e) {
      const {sortBy: sortBy} = e.detail;
      this.sortBy = sortBy;
      this.log("events", "sort:update", {
        sortBy: sortBy,
        tab: this.currentTab
      });
      this.firstLoadedPage = 1;
      this.lastLoadedPage = 1;
      this._dispatchProductPageLoad(1, "replace");
    }
    _performSearch() {
      const params = this.client._buildSearchParams(this.query, this.page, this.perPage, this.sortBy, this.filters);
      this.client.fetchProducts(params).then(({response: response, helpers: helpers}) => this._handleSearchSuccess(response, helpers)).catch(response => this._handleSearchFailure(response));
    }
    _dispatchProductPageLoad(page, mode) {
      this.page = page;
      this.paginationAction = {
        mode: mode,
        page: page
      };
      this._performSearch();
    }
    _dispatchInitialProductSearch() {
      this.currentTab = "products";
      this.page = Math.max(1, Number(this.page) || 1);
      const hasUrlFilters = this.filters && Object.keys(this.filters).length > 0;
      if (hasUrlFilters && !this.initialFilters) {
        this.log("network", "SearchResults:initial-dispatch:fetching-skeleton", {
          query: this.query
        });
        this.client.fetchWithSkeletonFallback(this.query, this.page, this.perPage, this.sortBy, this.filters).then(result => {
          if (result.initialFilters) {
            this.initialFilters = result.initialFilters;
            this.log("state", "filters:skeleton-cached", {
              count: this.initialFilters.length
            });
          }
          this._handleSearchSuccess(result.response, result.helpers);
        }).catch(() => this._performSearch());
      } else {
        this.log("network", "SearchResults:initial-dispatch:standard", {
          query: this.query
        });
        this._performSearch();
      }
    }
    _handleSearchSuccess(response, helpers) {
      const productsTotal = Number(response?.total_count || 0);
      const isInitialProductsPhase = !this.initStateMachine.productsResolved;
      if (isInitialProductsPhase) {
        this.log("network", "SearchResults:initial-phase:deferred-to-finalize", {
          totalCount: productsTotal,
          hasRedirectUrl: Boolean(response?.redirect_url),
          redirectUrl: response?.redirect_url || null,
          helpersRedirected: Boolean(helpers?.isRedirected?.())
        });
        this.initStateMachine.resolveProducts(response, helpers, true, productsTotal);
        return;
      }
      this.log("network", "SearchResults:onSuccess", {
        page: response?.page,
        requestedPage: this.paginationAction?.page ?? this.page,
        totalCount: response?.total_count,
        productsCount: response?.products?.length || 0,
        currentTab: this.currentTab,
        pendingAction: this.paginationAction?.mode || "replace",
        productsAvailable: this.tabAvailability.products
      });
      if (this.tabAvailabilityResolved) this.tabManager.updateTabVisibility();
      if ((0, $65zHg.handleRedirect)(helpers, response)) return;
      this.skeletonLoader.clearProducts();
      this.renderer.renderSearchResults(response, helpers);
      if (this._pendingScrollToResults) {
        this._pendingScrollToResults = false;
        this._scrollToResults();
      }
    }
    _handleSearchFailure(response) {
      const isInitialProductsPhase = !this.initStateMachine.productsResolved;
      if (isInitialProductsPhase) {
        this.initStateMachine.resolveProducts(null, null, false, 0);
        return;
      }
      this.log("errors", "SearchResults:onFailure", {
        response: response,
        requestedPage: this.paginationAction?.page ?? this.page,
        currentTab: this.currentTab
      });
      this.skeletonLoader.clearProducts();
      this.handleProductResultsRendered();
      console.warn("Tagalys search results v2 failed:", response);
    }
    loadCurrentTabResults=() => {
      this.log("events", "tab:load-results:start", {
        tab: this.currentTab,
        page: this.page,
        query: this.query
      });
      if (this.currentTab === "products") {
        this._performSearch();
        return;
      }
      const paginationContainer = this.querySelector("[data-search-pagination]");
      if (paginationContainer) paginationContainer.innerHTML = "";
      const headingCount = this.querySelector("#tagalys-search-count-inline");
      if (headingCount) headingCount.textContent = "";
      const currentStep = this.paginationManager.getNonProductStep(this.currentTab);
      const targetCount = this.paginationManager.getNonProductVisibleCountForStep(currentStep);
      const usingInitialCache = this.initialPlaintextResults && currentStep === 1;
      this.log("events", "tab:load-results:non-product-state", {
        tab: this.currentTab,
        currentStep: currentStep,
        targetCount: targetCount,
        requestCount: this.paginationManager.getNonProductRequestCountForStep(currentStep),
        usingInitialCache: usingInitialCache,
        hasInitialPlaintextResults: Boolean(this.initialPlaintextResults)
      });
      const previous = this.querySelector("[data-pagination-previous]");
      if (previous) previous.remove();
      if (usingInitialCache) {
        this.log("network", "SearchSuggestions:load:cached", {
          tab: this.currentTab
        });
        const payload = this.tabManager.normalizeSuggestionsResults({
          sections: this.initialPlaintextResults
        }, this.currentTab, targetCount);
        this.paginationManager.setNonProductStepForVisibleCount(this.currentTab, targetCount);
        this.skeletonLoader.clearPlaintext();
        this.tabManager.renderPlaintextResults(payload);
        return;
      }
      this.skeletonLoader.showPlaintext();
      const sectionCounts = this.suggestionsManager.getNonProductSectionCountsForRequest(this.tabManager, this.paginationManager, this.currentTab, currentStep);
      this.suggestionsManager.performSuggestionsSearchWithOptions(this.paginationManager, {
        tab: this.currentTab,
        step: currentStep,
        sectionCounts: sectionCounts,
        source: "loadCurrentTabResults"
      });
    };
    loadMorePlaintextResults=() => {
      this.suggestionsManager.loadMorePlaintextResults(this.paginationManager, this.tabManager);
    };
    updateSort=sortBy => {
      this.sortBy = sortBy;
      this.firstLoadedPage = 1;
      this.lastLoadedPage = 1;
      this._dispatchProductPageLoad(1, "replace");
    };
    handleProductResultsRendered=() => {
      this.paginationManager.setLoadingState("next", false);
      this.paginationManager.setLoadingState("previous", false);
    };
    syncUrlState=() => {
      (0, $92546df26b4e6577$export$b011c1f6ae44b5bf).sync(this.query, this.sortBy, this.page, this.filterManager.getApiPayload(), this.currentTab);
    };
    _setInitialPendingVisibility(isPending) {
      const filters = this.querySelector("#tagalys-search-filters");
      const productGrid = this.querySelector("[data-search-results]");
      const plaintext = this.querySelector("[data-search-plaintext-results]");
      if (isPending) {
        filters?.classList.add("hidden");
        productGrid?.classList.add("hidden");
        plaintext?.classList.add("hidden");
        return;
      }
      this.tabManager.applyTabState(this.currentTab);
    }
    _renderStoredInitialProductResults() {
      const {response: response, helpers: helpers} = this.initStateMachine.storedResponse;
      if (!response || !helpers) {
        this.log("errors", "initialization:render-products-skipped:no-response", {
          selectedTab: this.currentTab,
          productsResolved: this.initStateMachine.productsResolved
        });
        return;
      }
      this.log("network", "SearchResults:render-stored-initial", {
        hasRedirectUrl: Boolean(response?.redirect_url),
        helpersRedirected: Boolean(helpers?.isRedirected?.())
      });
      if ((0, $65zHg.handleRedirect)(helpers, response)) return;
      this.renderer.renderSearchResults(response, helpers);
    }
    _scrollToResults() {
      const resultsEl = this.querySelector("#tagalys-search-results");
      if (!resultsEl) return;
      const headerHeight = document.querySelector("header")?.clientHeight || 0;
      const padding = 120;
      const stickyTopOffset = headerHeight + padding;
      const resultsTop = resultsEl.getBoundingClientRect().top;
      if (resultsTop > stickyTopOffset) return;
      const target = resultsTop + window.scrollY - stickyTopOffset;
      window.scrollTo({
        top: Math.max(target, 0),
        behavior: "smooth"
      });
    }
  }
  if (!customElements.get("tagalys-search-results")) customElements.define("tagalys-search-results", $63afb175e9080251$var$TagalysSearchResults);
})();